/* eslint-disable */
/**
 * tslint:disable
 * Generated by orval 🍺
 * Do not edit manually.
 * mdp-admin-open-api-spec
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import { useMutator } from '../useMutator';
import type { ErrorType } from '../useMutator';
export type AccessPartner = { [key: string]: unknown };

export type AccountManager = { [key: string]: unknown };

export type AccountNumberDto = {
  id: string;
  organisationId: string;
  accountType: AccountType;
  productBlacklist?: string[];
  parcelTypeBlacklist?: string[];
  optionWhitelist?: string[];
  countryCode?: string;
  returnHubLinks?: ReturnHubLink[];
  blockedInfo?: BlockedInfo;
  selfOnboardingInfo?: SelfOnboardingInfoDto;
  activeProducts?: string[];
};

export type AccountType = typeof AccountType[keyof typeof AccountType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AccountType = {
  Parcel: 'Parcel',
  Verlader: 'Verlader',
  GMB: 'GMB',
} as const;

export type AccountVerificationException = {
  key: string;
  message: string;
};

export type AddAccountManagersToOrganizationDto = {
  accountManagers?: string[];
};

export type Address = {
  countryCode: string;
  zipCode?: string;
  city: string;
  street: string;
  additionalAddressLine?: string;
  number?: string;
  addition?: string;
  isBusiness: boolean;
  additionalInfo?: string;
};

export type AddressBookAddressDto = {
  countryCode?: string;
  zipCode?: string;
  city?: string;
  street?: string;
  additionalAddressLine?: string;
  number?: string;
  addition?: string;
  isBusiness: boolean;
  additionalInfo?: string;
};

export type AddressBookEntryDto = {
  id?: string;
  name: NameDto;
  email?: EmailDto;
  address: AddressBookAddressDto;
  tags?: string[];
  phoneNumber?: string;
  accountId?: string;
  reference?: string;
  eoriNumber?: string;
  vatNumber?: string;
  rexNumber?: string;
};

export type AddressDto = {
  countryCode: string;
  zipCode?: string;
  city: string;
  street: string;
  additionalAddressLine?: string;
  number?: string;
  addition?: string;
  isBusiness: boolean;
  additionalInfo?: string;
};

export type AllowedReturnPortalHandOffMethod = typeof AllowedReturnPortalHandOffMethod[keyof typeof AllowedReturnPortalHandOffMethod];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AllowedReturnPortalHandOffMethod = {
  pickup: 'pickup',
  service_point: 'service_point',
  consumer_pickup: 'consumer_pickup',
} as const;

export type AssignOrganisationsToAccountManagerDto = {
  organisations?: string[];
};

export type BadRequest = {
  key: string;
  message: string;
};

export type BillingUnitDto = {
  id?: string;
  name: string;
  description?: string;
  street?: string;
  number?: string;
  addition?: string;
  zipCode?: string;
  city?: string;
  countryCode?: string;
  cccId: string;
  trackerCodeMin?: number;
  trackerCodeMax?: number;
  trackerCodeLast?: number;
};

export type BlockReasonDto = CreditStop | SelfOnboardingLimitReached;

export type BlockedInfo = {
  isBlocked: boolean;
  since?: string;
  reason?: BlockReasonDto;
};

export type Business = { [key: string]: unknown };

export type BusinessPickupHandoffMethodView = {
  allowedCountries?: string[];
};

export type BusinessUnitCode = typeof BusinessUnitCode[keyof typeof BusinessUnitCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BusinessUnitCode = {
  'dhl-nl': 'dhl-nl',
  'dhl-be': 'dhl-be',
  'dhl-se': 'dhl-se',
  ccc: 'ccc',
  'apac-th': 'apac-th',
  'apac-my': 'apac-my',
  'ppl-cz': 'ppl-cz',
} as const;

export type BusinessUnitDto = {
  code: string;
  name: string;
};

export type Carrier = typeof Carrier[keyof typeof Carrier];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Carrier = {
  'DHL-PARCEL': 'DHL-PARCEL',
  'DHL-EXPRESS': 'DHL-EXPRESS',
  'DHL-EXPRESS-ECONOMY': 'DHL-EXPRESS-ECONOMY',
} as const;

export type ClientAuthenticationDto = {
  clientId: string;
  clientSecret: string;
};

export type Conflict = {
  key: string;
  message: string;
};

export type Consumer = { [key: string]: unknown };

export type ConsumerInterventions = { [key: string]: unknown };

export type ConsumerPickupHandoffMethodView = {
  options?: ReturnPortalOption[];
};

export type ContactPersonDto = {
  firstName: string;
  lastName: string;
  email: RequiredEmailDto;
  phone: string;
};

export type CreateAuthTokenDto = {
  userId: string;
  adminId: string;
};

export type CreateAuthTokenResponseDto = {
  token: string;
  url: string;
  tld: string;
};

export type CreditStop = { [key: string]: unknown };

export type CustomerReturnPortal = {
  customerPortalId: string;
  address: AddressBookEntryDto;
  logo?: string;
  handoffMethods?: ReturnPortalHandoffMethodView[];
  businessUnitCode?: BusinessUnitCode;
};

export type CustomsDeclarationFailed = {
  key: string;
  message: string;
};

export type Dimensions = {
  maxLengthCm: number;
  maxWidthCm: number;
  maxHeightCm: number;
  maxSumCm?: number;
};

export type EasySearchHitDto = {
  source?: string;
  correlationId?: string;
  timestamp?: string;
  payload?: string;
  errors?: HitError[];
};

export type EasySearchOverviewDto = {
  trackingCode?: string;
  flowName?: string;
  flowType?: string;
  fileName?: string;
  inputFormat?: string;
  outputFormat?: string;
  addedTimestamp?: string;
  correlationId?: string;
};

export type EasySearchResultDto = {
  overview?: EasySearchOverviewDto[];
  hits?: EasySearchHitDto[];
};

export type EmailDto = {
  address: string;
};

export type Error = {
  key: string;
  message: string;
};

export type ErrorResponse = AccountVerificationException | BadRequest | Conflict | CustomsDeclarationFailed | Error | Forbidden | MissingField | NotAuthorized | NotFound | RequiredFieldsError | ServerError | UnprocessableContent;

export type EveningDelivery = { [key: string]: unknown };

export type Firstmile = { [key: string]: unknown };

export type FlowTypesResultDto = {
  flowTypes?: string[];
};

export type Forbidden = {
  key: string;
  message: string;
};

export type GeneratePromoCodesCommand = {
  number: number;
  discountOnShippingCosts: number;
  validFrom: string;
  validUntil: string;
  maxUses: number;
  carriers?: Carrier[];
  fromCountries?: string[];
  toCountries?: string[];
};

export type HitError = {
  errorMessage: string;
  errorLevel: string;
  errorType: string;
};

export type IntegratorDto = {
  id?: string;
  name: string;
  description?: string;
  limitedTrackTrace: boolean;
};

export type Lastmile = { [key: string]: unknown };

export type MinimalUserDto = {
  email: RequiredEmailDto;
  name: NameDto;
};

export type MissingField = {
  key: string;
  message: string;
};

export type NameDto = {
  firstName?: string;
  lastName?: string;
  companyName?: string;
  additionalName?: string;
};

export type NewOrganisationDto = {
  name: string;
  data: OrganisationDataDto;
  useCompanyAddressBook: boolean;
  useSharedShipments: boolean;
  useSharedDrafts: boolean;
  useAdvancedParcelType?: boolean;
  businessUnitCode: string;
  ccc?: OrganisationCccDto;
  useSharedTickets?: boolean;
  useSharedImportSchemas: boolean;
};

export type NewReturnHub = {
  name: string;
  address: Address;
};

export type NotAuthorized = {
  key: string;
  message: string;
};

export type NotFound = {
  key: string;
  message: string;
};

export type NotHomeToServicepoint = { [key: string]: unknown };

export type Otc = { [key: string]: unknown };

export type OrganisationCccDto = {
  billingUnitId: string;
  customerId: string;
};

export type OrganisationCccIntegratorDto = {
  organisationId: string;
  integratorId: string;
  isAllowedToGetAll: boolean;
  integratorName?: string;
};

export type OrganisationDataDto = {
  address?: AddressDto;
  contactPerson?: ContactPersonDto;
  vatNumber?: string;
  chamberOfCommerce?: string;
  labelSettings?: OrganisationLabelSettingsDto;
};

export type OrganisationDto = {
  id: string;
  name: string;
  data: OrganisationDataDto;
  useCompanyAddressBook: boolean;
  useSharedShipments: boolean;
  useSharedDrafts: boolean;
  useAdvancedParcelType: boolean;
  businessUnitCode: string;
  ccc?: OrganisationCccDto;
  useSharedTickets: boolean;
  useSharedImportSchemas: boolean;
  enableEplPalDdpIncoterm?: boolean;
};

export type OrganisationLabelSettingsDto = {
  undeliverableReturnPostboxNumber?: string;
};

export type PageBillingUnitDto = {
  content?: BillingUnitDto[];
  totalCount: number;
};

export type PageIntegratorDto = {
  content?: IntegratorDto[];
  totalCount: number;
};

export type PageOrganisationDto = {
  content?: OrganisationDto[];
  totalCount: number;
};

export type PageParcelShop = {
  content?: ParcelShop[];
  totalCount: number;
};

export type PageUserDto = {
  content?: UserDto[];
  totalCount: number;
};

export type ParcelShop = {
  parcelShopPsfKey: string;
  debtorNumber: string;
  name: string;
  services?: ParcelShopService[];
  countryCode: string;
};

export type ParcelShop1 = { [key: string]: unknown };

export type ParcelShopManagerRequestDto = {
  email: RequiredEmailDto;
  name: NameDto;
  parcelShop: ParcelShop;
};

export type ParcelShopService = AccessPartner | ConsumerInterventions | EveningDelivery | Firstmile | Lastmile | NotHomeToServicepoint | Otc | Printless | Spa | SelfService;

export type ParcelType = {
  key: string;
  category: string;
  minWeightKg: number;
  maxWeightKg: number;
  defaultWeightKg: number;
  dimensions: Dimensions;
  price?: Price;
  minWeightGrams: number;
  maxWeightGrams: number;
  defaultWeightGrams: number;
};

export type PickupCreatedResponse = {
  confirmationNumber?: string;
  pickupDate?: string;
};

export type Price = {
  withoutTax: number;
  withTax: number;
  vatRate: number;
  currency: string;
};

export type Printless = { [key: string]: unknown };

export type PromoCodeDto = {
  key: string;
  discountOnShippingCosts: number;
  validFrom: string;
  validUntil: string;
  maxUses: number;
  currentUses: number;
  carriers?: Carrier[];
  fromCountries?: string[];
  toCountries?: string[];
};

export type RequiredEmailDto = {
  address: string;
};

export type RequiredFieldsError = {
  key: string;
  message: string;
  fields?: string[];
};

export type ReturnDeclarationMechanism = typeof ReturnDeclarationMechanism[keyof typeof ReturnDeclarationMechanism];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReturnDeclarationMechanism = {
  PrintedLabel: 'PrintedLabel',
  QrCode: 'QrCode',
} as const;

export type ReturnHub = {
  id: string;
  name: string;
  address: Address;
};

export type ReturnHubLink = {
  returnHubId: string;
  accountNumber: string;
  returnProductCode: string;
  locationId?: string;
  additionalCustomerInformation?: string;
};

export type ReturnHubResponse = {
  returnHubId: string;
};

export type ReturnPortalAddressDto = {
  countryCode: string;
  postalCode?: string;
  city: string;
  street: string;
  additionalAddressLine?: string;
  houseNumber?: string;
  houseNumberSuffix?: string;
  isBusiness: boolean;
};

export type ReturnPortalCapabilities = {
  returnType: AllowedReturnPortalHandOffMethod;
  countries?: string[];
  parcelTypes?: ParcelType[];
  options?: ReturnPortalOption[];
};

export type ReturnPortalHandoffMethodView = BusinessPickupHandoffMethodView | ConsumerPickupHandoffMethodView | ServicePointHandoffMethodView;

export type ReturnPortalOption = typeof ReturnPortalOption[keyof typeof ReturnPortalOption];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReturnPortalOption = {
  evening_timeslot: 'evening_timeslot',
} as const;

export type ReturnPortalPickupRequest = {
  captcha?: string;
  token?: string;
  sender: ReturnPortalSender;
  date: string;
  description?: string;
  packages: number;
  pallets: number;
  timeSlot?: TimeSlot;
};

export type ReturnPortalSender = {
  name: NameDto;
  address: ReturnPortalAddressDto;
  email: EmailDto;
};

export type ReturnPortalServicePointReturnRequestDto = {
  captcha?: string;
  token?: string;
  sender: ReturnPortalSender;
  reference: string;
  packageSizeConfirmed: boolean;
  returnDeclarationMechanism?: ReturnDeclarationMechanism;
};

export type RoleDto = {
  name: RoleNameDto;
  subRoles?: string[];
};

export type RoleNameDto = typeof RoleNameDto[keyof typeof RoleNameDto];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoleNameDto = {
  ServicepointEmployee: 'ServicepointEmployee',
  ServicepointManager: 'ServicepointManager',
  ServicepointSelfScan: 'ServicepointSelfScan',
  OrganisationUserManager: 'OrganisationUserManager',
  ReportingManager: 'ReportingManager',
  DeliveryReportingManager: 'DeliveryReportingManager',
  PickupManager: 'PickupManager',
  User: 'User',
  RateManager: 'RateManager',
  ApiGatewayUser: 'ApiGatewayUser',
  BetaUser: 'BetaUser',
  SupportTicketsUser: 'SupportTicketsUser',
  InterventionUser: 'InterventionUser',
  InterventionCancelUser: 'InterventionCancelUser',
  InterventionCourierUser: 'InterventionCourierUser',
  C2CUser: 'C2CUser',
  ANONYMOUS: 'ANONYMOUS',
  InterventionAgreedPlacePhotoUser: 'InterventionAgreedPlacePhotoUser',
  ShipmentsManagerUser: 'ShipmentsManagerUser',
  PusherConfigurationManager: 'PusherConfigurationManager',
} as const;

export type Spa = { [key: string]: unknown };

export type SelfOnboardingCustomerAdminRequest = {
  organisationId: string;
  accountNumber: string;
};

export type SelfOnboardingInfoDto = {
  accountNumber: string;
  since?: string;
  sentParcelsLastWeek: number;
  sentPalletsLastWeek: number;
};

export type SelfOnboardingLimitReached = { [key: string]: unknown };

export type SelfService = { [key: string]: unknown };

export type ServerError = {
  key: string;
  message: string;
};

export type ServicePointHandoffMethodView = {
  allowedCountries?: string[];
};

export type ServicePointReturnOrderCreatedDto = {
  servicePointLocatorUrl: string;
  servicePointIsPostalOffice: boolean;
  labels?: string[];
};

export type SuccessResponse = {
  code: number;
  key: string;
  message: string;
};

export type Terminal = { [key: string]: unknown };

export type TimeSlot = {
  from: string;
  to: string;
};

export type UnprocessableContent = {
  key: string;
  message: string;
};

export type UpdateReturnHubLinkResponse = {
  accountNumber: string;
};

export type UserDto = {
  email: RequiredEmailDto;
  id: string;
  name: NameDto;
  timeRegistered: string;
  timeUpdated: string;
  timeLastLogin: string;
  isBusinessUser: boolean;
  organisationId?: string;
  organisationType?: string;
  roles?: string[];
  accountNumbers?: string[];
  parcelShopPsfKey?: string;
  userType: UserType;
};

export type UserType = typeof UserType[keyof typeof UserType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserType = {
  parcelShop: 'parcelShop',
  consumer: 'consumer',
  business: 'business',
  accountManager: 'accountManager',
  terminal: 'terminal',
} as const;

export type GetIntegratorsParams = {
skip?: number;
max?: number;
query?: string;
};

export type GetRolesParams = {
userType?: UserType;
};

export type GetParcelShopsParams = {
query?: string;
skip?: number;
max?: number;
};

export type GetReportMarketingParams = {
startDate?: string;
endDate?: string;
products?: string;
countries?: string;
};

export type GetReportFinanceShipmentsParams = {
startDate?: string;
endDate?: string;
billingEntities?: string;
otcOnly?: boolean;
invoiceNrs?: string;
productKeys?: string;
countries?: string;
};

export type GetReportFinanceDownloadpaymentsParams = {
startDate?: string;
endDate?: string;
productKeys?: string;
countries?: string;
};

export type GetOnboardingDataReportParams = {
/**
 * Year to export data for
 */
year?: number;
/**
 * Month to export data for
 */
month?: number;
};

export type CreateReturnPortalServicePointReturnOrderParams = {
locale?: string;
};

export type GetUsersParams = {
query?: string;
skip?: number;
max?: number;
userType?: UserType[];
};

export type GetOrganisationsParams = {
query?: string;
skip?: number;
max?: number;
};

export type GetAccountManagersByOrganisationParams = {
query?: string;
skip?: number;
max?: number;
};

export type GetOrganisationsByAcccountManagerParams = {
query?: string;
skip?: number;
max?: number;
};

export type GetTerminalOrganisationsParams = {
query?: string;
skip?: number;
max?: number;
};

export type GetBillingUnitsParams = {
skip?: number;
max?: number;
query?: string;
};

export type PidSearchParams = {
parcelId: string;
flowType: string;
};

export type GetBlobsParams = {
filePath: string;
};

export type InterventionExportParams = {
startDate: string;
endDate: string;
};

export type GetPromoCodesParams = {
/**
 * Filter by user-generated codes (default: true)
 */
userGenerated?: boolean;
};

export type GetBillingUnitsForAdminParams = {
skip?: number;
max?: number;
query?: string;
};

export const useGetIntegratorHook = () => {
        const getIntegrator = useMutator<IntegratorDto>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {
        return getIntegrator(
          {url: `/api/v2/ccc/integrator/${id}`, method: 'GET', signal
    },
          );
        }, [getIntegrator])
      }
    

export const getGetIntegratorQueryKey = (id?: string,) => {
    return [`/api/v2/ccc/integrator/${id}`] as const;
    }

    
export const useGetIntegratorQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegratorQueryKey(id);

  const getIntegrator =  useGetIntegratorHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>> = ({ signal }) => getIntegrator(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegratorQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>>
export type GetIntegratorQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetIntegrator<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrator<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrator<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIntegrator<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetIntegratorQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useDeleteIntegratorHook = () => {
        const deleteIntegrator = useMutator<null>();

        return useCallback((
    id: string,
 ) => {
        return deleteIntegrator(
          {url: `/api/v2/ccc/integrator/${id}`, method: 'DELETE'
    },
          );
        }, [deleteIntegrator])
      }
    


export const useDeleteIntegratorMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteIntegratorHook>>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteIntegratorHook>>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteIntegrator'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteIntegrator =  useDeleteIntegratorHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteIntegratorHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteIntegrator(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteIntegratorMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteIntegratorHook>>>>
    
    export type DeleteIntegratorMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteIntegrator = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteIntegratorHook>>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteIntegratorHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteIntegratorMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetIntegratorsHook = () => {
        const getIntegrators = useMutator<PageIntegratorDto>();

        return useCallback((
    params?: GetIntegratorsParams,
 signal?: AbortSignal
) => {
        return getIntegrators(
          {url: `/api/v2/ccc/integrator`, method: 'GET',
        params, signal
    },
          );
        }, [getIntegrators])
      }
    

export const getGetIntegratorsQueryKey = (params?: GetIntegratorsParams,) => {
    return [`/api/v2/ccc/integrator`, ...(params ? [params]: [])] as const;
    }

    
export const useGetIntegratorsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetIntegratorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegratorsQueryKey(params);

  const getIntegrators =  useGetIntegratorsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>> = ({ signal }) => getIntegrators(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegratorsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>>
export type GetIntegratorsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetIntegrators<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetIntegratorsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrators<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetIntegratorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegrators<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetIntegratorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIntegrators<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetIntegratorsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetIntegratorsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutIntegratorHook = () => {
        const putIntegrator = useMutator<null>();

        return useCallback((
    integratorDto: IntegratorDto,
 ) => {
        return putIntegrator(
          {url: `/api/v2/ccc/integrator`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: integratorDto
    },
          );
        }, [putIntegrator])
      }
    


export const usePutIntegratorMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutIntegratorHook>>>, TError,{data: IntegratorDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutIntegratorHook>>>, TError,{data: IntegratorDto}, TContext> => {

const mutationKey = ['putIntegrator'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putIntegrator =  usePutIntegratorHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutIntegratorHook>>>, {data: IntegratorDto}> = (props) => {
          const {data} = props ?? {};

          return  putIntegrator(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutIntegratorMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutIntegratorHook>>>>
    export type PutIntegratorMutationBody = IntegratorDto
    export type PutIntegratorMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const usePutIntegrator = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutIntegratorHook>>>, TError,{data: IntegratorDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutIntegratorHook>>>,
        TError,
        {data: IntegratorDto},
        TContext
      > => {

      const mutationOptions = usePutIntegratorMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePostIntegratorHook = () => {
        const postIntegrator = useMutator<null>();

        return useCallback((
    integratorDto: IntegratorDto,
 signal?: AbortSignal
) => {
        return postIntegrator(
          {url: `/api/v2/ccc/integrator`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: integratorDto, signal
    },
          );
        }, [postIntegrator])
      }
    


export const usePostIntegratorMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostIntegratorHook>>>, TError,{data: IntegratorDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostIntegratorHook>>>, TError,{data: IntegratorDto}, TContext> => {

const mutationKey = ['postIntegrator'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postIntegrator =  usePostIntegratorHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostIntegratorHook>>>, {data: IntegratorDto}> = (props) => {
          const {data} = props ?? {};

          return  postIntegrator(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostIntegratorMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostIntegratorHook>>>>
    export type PostIntegratorMutationBody = IntegratorDto
    export type PostIntegratorMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const usePostIntegrator = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostIntegratorHook>>>, TError,{data: IntegratorDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostIntegratorHook>>>,
        TError,
        {data: IntegratorDto},
        TContext
      > => {

      const mutationOptions = usePostIntegratorMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetIntegratorCCCApiCredentialsHook = () => {
        const getIntegratorCCCApiCredentials = useMutator<ClientAuthenticationDto>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {
        return getIntegratorCCCApiCredentials(
          {url: `/api/v2/ccc/integrator/${id}/ccc-api-credentials`, method: 'GET', signal
    },
          );
        }, [getIntegratorCCCApiCredentials])
      }
    

export const getGetIntegratorCCCApiCredentialsQueryKey = (id?: string,) => {
    return [`/api/v2/ccc/integrator/${id}/ccc-api-credentials`] as const;
    }

    
export const useGetIntegratorCCCApiCredentialsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetIntegratorCCCApiCredentialsQueryKey(id);

  const getIntegratorCCCApiCredentials =  useGetIntegratorCCCApiCredentialsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>> = ({ signal }) => getIntegratorCCCApiCredentials(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetIntegratorCCCApiCredentialsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>>
export type GetIntegratorCCCApiCredentialsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetIntegratorCCCApiCredentials<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegratorCCCApiCredentials<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetIntegratorCCCApiCredentials<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetIntegratorCCCApiCredentials<TData = Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetIntegratorCCCApiCredentialsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetIntegratorCCCApiCredentialsQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetRolesHook = () => {
        const getRoles = useMutator<RoleDto[]>();

        return useCallback((
    params?: GetRolesParams,
 signal?: AbortSignal
) => {
        return getRoles(
          {url: `/api/v2/roles`, method: 'GET',
        params, signal
    },
          );
        }, [getRoles])
      }
    

export const getGetRolesQueryKey = (params?: GetRolesParams,) => {
    return [`/api/v2/roles`, ...(params ? [params]: [])] as const;
    }

    
export const useGetRolesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRolesQueryKey(params);

  const getRoles =  useGetRolesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>> = ({ signal }) => getRoles(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetRolesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>>
export type GetRolesQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetRolesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetRolesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetRolesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetRolesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get all parcel shops with optional search and pagination
 */
export const useGetParcelShopsHook = () => {
        const getParcelShops = useMutator<PageParcelShop>();

        return useCallback((
    params?: GetParcelShopsParams,
 signal?: AbortSignal
) => {
        return getParcelShops(
          {url: `/api/v2/parcel-shops`, method: 'GET',
        params, signal
    },
          );
        }, [getParcelShops])
      }
    

export const getGetParcelShopsQueryKey = (params?: GetParcelShopsParams,) => {
    return [`/api/v2/parcel-shops`, ...(params ? [params]: [])] as const;
    }

    
export const useGetParcelShopsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetParcelShopsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetParcelShopsQueryKey(params);

  const getParcelShops =  useGetParcelShopsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>> = ({ signal }) => getParcelShops(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetParcelShopsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>>
export type GetParcelShopsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetParcelShops<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetParcelShopsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShops<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetParcelShopsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShops<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetParcelShopsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetParcelShops<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetParcelShopsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetParcelShopsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a single parcel shop by its parcelShopPsfKey
 */
export const useGetParcelShopHook = () => {
        const getParcelShop = useMutator<ParcelShop>();

        return useCallback((
    parcelShopPsfKey: string,
 signal?: AbortSignal
) => {
        return getParcelShop(
          {url: `/api/v2/parcel-shops/${parcelShopPsfKey}`, method: 'GET', signal
    },
          );
        }, [getParcelShop])
      }
    

export const getGetParcelShopQueryKey = (parcelShopPsfKey?: string,) => {
    return [`/api/v2/parcel-shops/${parcelShopPsfKey}`] as const;
    }

    
export const useGetParcelShopQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(parcelShopPsfKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetParcelShopQueryKey(parcelShopPsfKey);

  const getParcelShop =  useGetParcelShopHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>> = ({ signal }) => getParcelShop(parcelShopPsfKey, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(parcelShopPsfKey),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetParcelShopQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>>
export type GetParcelShopQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetParcelShop<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 parcelShopPsfKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShop<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 parcelShopPsfKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShop<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 parcelShopPsfKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetParcelShop<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 parcelShopPsfKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetParcelShopQueryOptions(parcelShopPsfKey,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get all users associated with a specific parcel shop
 */
export const useGetParcelShopUsersHook = () => {
        const getParcelShopUsers = useMutator<UserDto[]>();

        return useCallback((
    parcelShopPsfKey: string,
 signal?: AbortSignal
) => {
        return getParcelShopUsers(
          {url: `/api/v2/parcel-shops/${parcelShopPsfKey}/users`, method: 'GET', signal
    },
          );
        }, [getParcelShopUsers])
      }
    

export const getGetParcelShopUsersQueryKey = (parcelShopPsfKey?: string,) => {
    return [`/api/v2/parcel-shops/${parcelShopPsfKey}/users`] as const;
    }

    
export const useGetParcelShopUsersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(parcelShopPsfKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetParcelShopUsersQueryKey(parcelShopPsfKey);

  const getParcelShopUsers =  useGetParcelShopUsersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>> = ({ signal }) => getParcelShopUsers(parcelShopPsfKey, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(parcelShopPsfKey),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetParcelShopUsersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>>
export type GetParcelShopUsersQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetParcelShopUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 parcelShopPsfKey: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShopUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 parcelShopPsfKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShopUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 parcelShopPsfKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetParcelShopUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 parcelShopPsfKey: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopUsersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetParcelShopUsersQueryOptions(parcelShopPsfKey,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get the parcel shop associated with a specific user
 */
export const useGetParcelShopForUserHook = () => {
        const getParcelShopForUser = useMutator<ParcelShop>();

        return useCallback((
    emailOrId: string,
 signal?: AbortSignal
) => {
        return getParcelShopForUser(
          {url: `/api/v2/users/${emailOrId}/parcel-shop`, method: 'GET', signal
    },
          );
        }, [getParcelShopForUser])
      }
    

export const getGetParcelShopForUserQueryKey = (emailOrId?: string,) => {
    return [`/api/v2/users/${emailOrId}/parcel-shop`] as const;
    }

    
export const useGetParcelShopForUserQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetParcelShopForUserQueryKey(emailOrId);

  const getParcelShopForUser =  useGetParcelShopForUserHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>> = ({ signal }) => getParcelShopForUser(emailOrId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(emailOrId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetParcelShopForUserQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>>
export type GetParcelShopForUserQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetParcelShopForUser<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShopForUser<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetParcelShopForUser<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetParcelShopForUser<TData = Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetParcelShopForUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetParcelShopForUserQueryOptions(emailOrId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Remove the parcel shop association from a specific user
 */
export const useDeleteParcelShopForUserHook = () => {
        const deleteParcelShopForUser = useMutator<null>();

        return useCallback((
    emailOrId: string,
 ) => {
        return deleteParcelShopForUser(
          {url: `/api/v2/users/${emailOrId}/parcel-shop`, method: 'DELETE'
    },
          );
        }, [deleteParcelShopForUser])
      }
    


export const useDeleteParcelShopForUserMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteParcelShopForUserHook>>>, TError,{emailOrId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteParcelShopForUserHook>>>, TError,{emailOrId: string}, TContext> => {

const mutationKey = ['deleteParcelShopForUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteParcelShopForUser =  useDeleteParcelShopForUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteParcelShopForUserHook>>>, {emailOrId: string}> = (props) => {
          const {emailOrId} = props ?? {};

          return  deleteParcelShopForUser(emailOrId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteParcelShopForUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteParcelShopForUserHook>>>>
    
    export type DeleteParcelShopForUserMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteParcelShopForUser = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteParcelShopForUserHook>>>, TError,{emailOrId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteParcelShopForUserHook>>>,
        TError,
        {emailOrId: string},
        TContext
      > => {

      const mutationOptions = useDeleteParcelShopForUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Associate a user with a specific parcel shop
 */
export const useUpdateParcelShopForUserHook = () => {
        const updateParcelShopForUser = useMutator<null>();

        return useCallback((
    emailOrId: string,
    parcelShopPsfKey: string,
 ) => {
        return updateParcelShopForUser(
          {url: `/api/v2/users/${emailOrId}/parcel-shop/${parcelShopPsfKey}`, method: 'PUT'
    },
          );
        }, [updateParcelShopForUser])
      }
    


export const useUpdateParcelShopForUserMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateParcelShopForUserHook>>>, TError,{emailOrId: string;parcelShopPsfKey: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateParcelShopForUserHook>>>, TError,{emailOrId: string;parcelShopPsfKey: string}, TContext> => {

const mutationKey = ['updateParcelShopForUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateParcelShopForUser =  useUpdateParcelShopForUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateParcelShopForUserHook>>>, {emailOrId: string;parcelShopPsfKey: string}> = (props) => {
          const {emailOrId,parcelShopPsfKey} = props ?? {};

          return  updateParcelShopForUser(emailOrId,parcelShopPsfKey,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateParcelShopForUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateParcelShopForUserHook>>>>
    
    export type UpdateParcelShopForUserMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdateParcelShopForUser = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateParcelShopForUserHook>>>, TError,{emailOrId: string;parcelShopPsfKey: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateParcelShopForUserHook>>>,
        TError,
        {emailOrId: string;parcelShopPsfKey: string},
        TContext
      > => {

      const mutationOptions = useUpdateParcelShopForUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetReportMarketingHook = () => {
        const getReportMarketing = useMutator<Blob>();

        return useCallback((
    params?: GetReportMarketingParams,
 signal?: AbortSignal
) => {
        return getReportMarketing(
          {url: `/api/v2/report/marketing`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
          );
        }, [getReportMarketing])
      }
    

export const getGetReportMarketingQueryKey = (params?: GetReportMarketingParams,) => {
    return [`/api/v2/report/marketing`, ...(params ? [params]: [])] as const;
    }

    
export const useGetReportMarketingQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetReportMarketingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportMarketingQueryKey(params);

  const getReportMarketing =  useGetReportMarketingHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>> = ({ signal }) => getReportMarketing(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportMarketingQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>>
export type GetReportMarketingQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetReportMarketing<TData = Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetReportMarketingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportMarketing<TData = Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetReportMarketingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportMarketing<TData = Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetReportMarketingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReportMarketing<TData = Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetReportMarketingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportMarketingHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetReportMarketingQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetReportFinanceShipmentsHook = () => {
        const getReportFinanceShipments = useMutator<Blob>();

        return useCallback((
    params?: GetReportFinanceShipmentsParams,
 signal?: AbortSignal
) => {
        return getReportFinanceShipments(
          {url: `/api/v2/report/finance/shipments`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
          );
        }, [getReportFinanceShipments])
      }
    

export const getGetReportFinanceShipmentsQueryKey = (params?: GetReportFinanceShipmentsParams,) => {
    return [`/api/v2/report/finance/shipments`, ...(params ? [params]: [])] as const;
    }

    
export const useGetReportFinanceShipmentsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetReportFinanceShipmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportFinanceShipmentsQueryKey(params);

  const getReportFinanceShipments =  useGetReportFinanceShipmentsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>> = ({ signal }) => getReportFinanceShipments(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportFinanceShipmentsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>>
export type GetReportFinanceShipmentsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetReportFinanceShipments<TData = Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetReportFinanceShipmentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportFinanceShipments<TData = Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetReportFinanceShipmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportFinanceShipments<TData = Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetReportFinanceShipmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReportFinanceShipments<TData = Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetReportFinanceShipmentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceShipmentsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetReportFinanceShipmentsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetReportFinanceDownloadpaymentsHook = () => {
        const getReportFinanceDownloadpayments = useMutator<Blob>();

        return useCallback((
    params?: GetReportFinanceDownloadpaymentsParams,
 signal?: AbortSignal
) => {
        return getReportFinanceDownloadpayments(
          {url: `/api/v2/report/finance/downloadPayments`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
          );
        }, [getReportFinanceDownloadpayments])
      }
    

export const getGetReportFinanceDownloadpaymentsQueryKey = (params?: GetReportFinanceDownloadpaymentsParams,) => {
    return [`/api/v2/report/finance/downloadPayments`, ...(params ? [params]: [])] as const;
    }

    
export const useGetReportFinanceDownloadpaymentsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetReportFinanceDownloadpaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReportFinanceDownloadpaymentsQueryKey(params);

  const getReportFinanceDownloadpayments =  useGetReportFinanceDownloadpaymentsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>> = ({ signal }) => getReportFinanceDownloadpayments(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReportFinanceDownloadpaymentsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>>
export type GetReportFinanceDownloadpaymentsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetReportFinanceDownloadpayments<TData = Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetReportFinanceDownloadpaymentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportFinanceDownloadpayments<TData = Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetReportFinanceDownloadpaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReportFinanceDownloadpayments<TData = Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetReportFinanceDownloadpaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReportFinanceDownloadpayments<TData = Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetReportFinanceDownloadpaymentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReportFinanceDownloadpaymentsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetReportFinanceDownloadpaymentsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetOnboardingDataReportHook = () => {
        const getOnboardingDataReport = useMutator<string>();

        return useCallback((
    params?: GetOnboardingDataReportParams,
 signal?: AbortSignal
) => {
        return getOnboardingDataReport(
          {url: `/api/v2/report/finance/onboarding-data`, method: 'GET',
        params, signal
    },
          );
        }, [getOnboardingDataReport])
      }
    

export const getGetOnboardingDataReportQueryKey = (params?: GetOnboardingDataReportParams,) => {
    return [`/api/v2/report/finance/onboarding-data`, ...(params ? [params]: [])] as const;
    }

    
export const useGetOnboardingDataReportQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetOnboardingDataReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnboardingDataReportQueryKey(params);

  const getOnboardingDataReport =  useGetOnboardingDataReportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>> = ({ signal }) => getOnboardingDataReport(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOnboardingDataReportQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>>
export type GetOnboardingDataReportQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetOnboardingDataReport<TData = Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetOnboardingDataReportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingDataReport<TData = Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetOnboardingDataReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOnboardingDataReport<TData = Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetOnboardingDataReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOnboardingDataReport<TData = Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetOnboardingDataReportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOnboardingDataReportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOnboardingDataReportQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetReturnPortalHook = () => {
        const getReturnPortal = useMutator<CustomerReturnPortal>();

        return useCallback((
    customerPortalId: string,
 signal?: AbortSignal
) => {
        return getReturnPortal(
          {url: `/api/v2/return-portals/${customerPortalId}`, method: 'GET', signal
    },
          );
        }, [getReturnPortal])
      }
    

export const getGetReturnPortalQueryKey = (customerPortalId?: string,) => {
    return [`/api/v2/return-portals/${customerPortalId}`] as const;
    }

    
export const useGetReturnPortalQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(customerPortalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReturnPortalQueryKey(customerPortalId);

  const getReturnPortal =  useGetReturnPortalHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>> = ({ signal }) => getReturnPortal(customerPortalId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(customerPortalId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReturnPortalQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>>
export type GetReturnPortalQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetReturnPortal<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 customerPortalId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReturnPortal<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 customerPortalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReturnPortal<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 customerPortalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReturnPortal<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 customerPortalId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetReturnPortalQueryOptions(customerPortalId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useCreateReturnPortalServicePointReturnOrderHook = () => {
        const createReturnPortalServicePointReturnOrder = useMutator<ServicePointReturnOrderCreatedDto>();

        return useCallback((
    customerPortalId: string,
    returnPortalServicePointReturnRequestDto: ReturnPortalServicePointReturnRequestDto,
    params?: CreateReturnPortalServicePointReturnOrderParams,
 signal?: AbortSignal
) => {
        return createReturnPortalServicePointReturnOrder(
          {url: `/api/v2/return-portals/${customerPortalId}/service-point-return`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: returnPortalServicePointReturnRequestDto,
        params, signal
    },
          );
        }, [createReturnPortalServicePointReturnOrder])
      }
    


export const useCreateReturnPortalServicePointReturnOrderMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalServicePointReturnOrderHook>>>, TError,{customerPortalId: string;data: ReturnPortalServicePointReturnRequestDto;params?: CreateReturnPortalServicePointReturnOrderParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalServicePointReturnOrderHook>>>, TError,{customerPortalId: string;data: ReturnPortalServicePointReturnRequestDto;params?: CreateReturnPortalServicePointReturnOrderParams}, TContext> => {

const mutationKey = ['createReturnPortalServicePointReturnOrder'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createReturnPortalServicePointReturnOrder =  useCreateReturnPortalServicePointReturnOrderHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalServicePointReturnOrderHook>>>, {customerPortalId: string;data: ReturnPortalServicePointReturnRequestDto;params?: CreateReturnPortalServicePointReturnOrderParams}> = (props) => {
          const {customerPortalId,data,params} = props ?? {};

          return  createReturnPortalServicePointReturnOrder(customerPortalId,data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateReturnPortalServicePointReturnOrderMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalServicePointReturnOrderHook>>>>
    export type CreateReturnPortalServicePointReturnOrderMutationBody = ReturnPortalServicePointReturnRequestDto
    export type CreateReturnPortalServicePointReturnOrderMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreateReturnPortalServicePointReturnOrder = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalServicePointReturnOrderHook>>>, TError,{customerPortalId: string;data: ReturnPortalServicePointReturnRequestDto;params?: CreateReturnPortalServicePointReturnOrderParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalServicePointReturnOrderHook>>>,
        TError,
        {customerPortalId: string;data: ReturnPortalServicePointReturnRequestDto;params?: CreateReturnPortalServicePointReturnOrderParams},
        TContext
      > => {

      const mutationOptions = useCreateReturnPortalServicePointReturnOrderMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useCreateReturnPortalPickupRequestHook = () => {
        const createReturnPortalPickupRequest = useMutator<PickupCreatedResponse>();

        return useCallback((
    customerPortalId: string,
    returnPortalPickupRequest: ReturnPortalPickupRequest,
 signal?: AbortSignal
) => {
        return createReturnPortalPickupRequest(
          {url: `/api/v2/return-portals/${customerPortalId}/pickup`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: returnPortalPickupRequest, signal
    },
          );
        }, [createReturnPortalPickupRequest])
      }
    


export const useCreateReturnPortalPickupRequestMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalPickupRequestHook>>>, TError,{customerPortalId: string;data: ReturnPortalPickupRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalPickupRequestHook>>>, TError,{customerPortalId: string;data: ReturnPortalPickupRequest}, TContext> => {

const mutationKey = ['createReturnPortalPickupRequest'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createReturnPortalPickupRequest =  useCreateReturnPortalPickupRequestHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalPickupRequestHook>>>, {customerPortalId: string;data: ReturnPortalPickupRequest}> = (props) => {
          const {customerPortalId,data} = props ?? {};

          return  createReturnPortalPickupRequest(customerPortalId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateReturnPortalPickupRequestMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalPickupRequestHook>>>>
    export type CreateReturnPortalPickupRequestMutationBody = ReturnPortalPickupRequest
    export type CreateReturnPortalPickupRequestMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreateReturnPortalPickupRequest = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalPickupRequestHook>>>, TError,{customerPortalId: string;data: ReturnPortalPickupRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateReturnPortalPickupRequestHook>>>,
        TError,
        {customerPortalId: string;data: ReturnPortalPickupRequest},
        TContext
      > => {

      const mutationOptions = useCreateReturnPortalPickupRequestMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetReturnPortalCapabilitiesHook = () => {
        const getReturnPortalCapabilities = useMutator<ReturnPortalCapabilities[]>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getReturnPortalCapabilities(
          {url: `/api/v2/return-portals/capabilities`, method: 'GET', signal
    },
          );
        }, [getReturnPortalCapabilities])
      }
    

export const getGetReturnPortalCapabilitiesQueryKey = () => {
    return [`/api/v2/return-portals/capabilities`] as const;
    }

    
export const useGetReturnPortalCapabilitiesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReturnPortalCapabilitiesQueryKey();

  const getReturnPortalCapabilities =  useGetReturnPortalCapabilitiesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>> = ({ signal }) => getReturnPortalCapabilities(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReturnPortalCapabilitiesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>>
export type GetReturnPortalCapabilitiesQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetReturnPortalCapabilities<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReturnPortalCapabilities<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReturnPortalCapabilities<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReturnPortalCapabilities<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnPortalCapabilitiesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetReturnPortalCapabilitiesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetOrganisationOrganisationidAccountNumbersHook = () => {
        const getOrganisationOrganisationidAccountNumbers = useMutator<AccountNumberDto[]>();

        return useCallback((
    organisationId: string,
 signal?: AbortSignal
) => {
        return getOrganisationOrganisationidAccountNumbers(
          {url: `/api/v2/organisation/${organisationId}/account-numbers`, method: 'GET', signal
    },
          );
        }, [getOrganisationOrganisationidAccountNumbers])
      }
    

export const getGetOrganisationOrganisationidAccountNumbersQueryKey = (organisationId?: string,) => {
    return [`/api/v2/organisation/${organisationId}/account-numbers`] as const;
    }

    
export const useGetOrganisationOrganisationidAccountNumbersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganisationOrganisationidAccountNumbersQueryKey(organisationId);

  const getOrganisationOrganisationidAccountNumbers =  useGetOrganisationOrganisationidAccountNumbersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>> = ({ signal }) => getOrganisationOrganisationidAccountNumbers(organisationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organisationId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganisationOrganisationidAccountNumbersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>>
export type GetOrganisationOrganisationidAccountNumbersQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetOrganisationOrganisationidAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationOrganisationidAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationOrganisationidAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganisationOrganisationidAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOrganisationOrganisationidAccountNumbersQueryOptions(organisationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostOrganisationOrganisationidAccountNumbersHook = () => {
        const postOrganisationOrganisationidAccountNumbers = useMutator<null>();

        return useCallback((
    organisationId: string,
    accountNumberDto: AccountNumberDto,
 signal?: AbortSignal
) => {
        return postOrganisationOrganisationidAccountNumbers(
          {url: `/api/v2/organisation/${organisationId}/account-numbers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountNumberDto, signal
    },
          );
        }, [postOrganisationOrganisationidAccountNumbers])
      }
    


export const usePostOrganisationOrganisationidAccountNumbersMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostOrganisationOrganisationidAccountNumbersHook>>>, TError,{organisationId: string;data: AccountNumberDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostOrganisationOrganisationidAccountNumbersHook>>>, TError,{organisationId: string;data: AccountNumberDto}, TContext> => {

const mutationKey = ['postOrganisationOrganisationidAccountNumbers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postOrganisationOrganisationidAccountNumbers =  usePostOrganisationOrganisationidAccountNumbersHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostOrganisationOrganisationidAccountNumbersHook>>>, {organisationId: string;data: AccountNumberDto}> = (props) => {
          const {organisationId,data} = props ?? {};

          return  postOrganisationOrganisationidAccountNumbers(organisationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostOrganisationOrganisationidAccountNumbersMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostOrganisationOrganisationidAccountNumbersHook>>>>
    export type PostOrganisationOrganisationidAccountNumbersMutationBody = AccountNumberDto
    export type PostOrganisationOrganisationidAccountNumbersMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const usePostOrganisationOrganisationidAccountNumbers = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostOrganisationOrganisationidAccountNumbersHook>>>, TError,{organisationId: string;data: AccountNumberDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostOrganisationOrganisationidAccountNumbersHook>>>,
        TError,
        {organisationId: string;data: AccountNumberDto},
        TContext
      > => {

      const mutationOptions = usePostOrganisationOrganisationidAccountNumbersMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetTerminalOrganisationidAccountNumbersHook = () => {
        const getTerminalOrganisationidAccountNumbers = useMutator<AccountNumberDto[]>();

        return useCallback((
    organisationId: string,
 signal?: AbortSignal
) => {
        return getTerminalOrganisationidAccountNumbers(
          {url: `/api/v2/terminal/${organisationId}/account-numbers`, method: 'GET', signal
    },
          );
        }, [getTerminalOrganisationidAccountNumbers])
      }
    

export const getGetTerminalOrganisationidAccountNumbersQueryKey = (organisationId?: string,) => {
    return [`/api/v2/terminal/${organisationId}/account-numbers`] as const;
    }

    
export const useGetTerminalOrganisationidAccountNumbersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTerminalOrganisationidAccountNumbersQueryKey(organisationId);

  const getTerminalOrganisationidAccountNumbers =  useGetTerminalOrganisationidAccountNumbersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>> = ({ signal }) => getTerminalOrganisationidAccountNumbers(organisationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organisationId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTerminalOrganisationidAccountNumbersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>>
export type GetTerminalOrganisationidAccountNumbersQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetTerminalOrganisationidAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTerminalOrganisationidAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTerminalOrganisationidAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTerminalOrganisationidAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTerminalOrganisationidAccountNumbersQueryOptions(organisationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePostTerminalOrganisationidAccountNumbersHook = () => {
        const postTerminalOrganisationidAccountNumbers = useMutator<null>();

        return useCallback((
    organisationId: string,
    accountNumberDto: AccountNumberDto,
 signal?: AbortSignal
) => {
        return postTerminalOrganisationidAccountNumbers(
          {url: `/api/v2/terminal/${organisationId}/account-numbers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountNumberDto, signal
    },
          );
        }, [postTerminalOrganisationidAccountNumbers])
      }
    


export const usePostTerminalOrganisationidAccountNumbersMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTerminalOrganisationidAccountNumbersHook>>>, TError,{organisationId: string;data: AccountNumberDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTerminalOrganisationidAccountNumbersHook>>>, TError,{organisationId: string;data: AccountNumberDto}, TContext> => {

const mutationKey = ['postTerminalOrganisationidAccountNumbers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postTerminalOrganisationidAccountNumbers =  usePostTerminalOrganisationidAccountNumbersHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostTerminalOrganisationidAccountNumbersHook>>>, {organisationId: string;data: AccountNumberDto}> = (props) => {
          const {organisationId,data} = props ?? {};

          return  postTerminalOrganisationidAccountNumbers(organisationId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostTerminalOrganisationidAccountNumbersMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostTerminalOrganisationidAccountNumbersHook>>>>
    export type PostTerminalOrganisationidAccountNumbersMutationBody = AccountNumberDto
    export type PostTerminalOrganisationidAccountNumbersMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const usePostTerminalOrganisationidAccountNumbers = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostTerminalOrganisationidAccountNumbersHook>>>, TError,{organisationId: string;data: AccountNumberDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostTerminalOrganisationidAccountNumbersHook>>>,
        TError,
        {organisationId: string;data: AccountNumberDto},
        TContext
      > => {

      const mutationOptions = usePostTerminalOrganisationidAccountNumbersMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetOrganisationOrganisationidAccountNumbersActiveProductsHook = () => {
        const getOrganisationOrganisationidAccountNumbersActiveProducts = useMutator<AccountNumberDto[]>();

        return useCallback((
    organisationId: string,
 signal?: AbortSignal
) => {
        return getOrganisationOrganisationidAccountNumbersActiveProducts(
          {url: `/api/v2/organisation/${organisationId}/account-numbers-active-products`, method: 'GET', signal
    },
          );
        }, [getOrganisationOrganisationidAccountNumbersActiveProducts])
      }
    

export const getGetOrganisationOrganisationidAccountNumbersActiveProductsQueryKey = (organisationId?: string,) => {
    return [`/api/v2/organisation/${organisationId}/account-numbers-active-products`] as const;
    }

    
export const useGetOrganisationOrganisationidAccountNumbersActiveProductsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganisationOrganisationidAccountNumbersActiveProductsQueryKey(organisationId);

  const getOrganisationOrganisationidAccountNumbersActiveProducts =  useGetOrganisationOrganisationidAccountNumbersActiveProductsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>> = ({ signal }) => getOrganisationOrganisationidAccountNumbersActiveProducts(organisationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organisationId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganisationOrganisationidAccountNumbersActiveProductsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>>
export type GetOrganisationOrganisationidAccountNumbersActiveProductsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetOrganisationOrganisationidAccountNumbersActiveProducts<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationOrganisationidAccountNumbersActiveProducts<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationOrganisationidAccountNumbersActiveProducts<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganisationOrganisationidAccountNumbersActiveProducts<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOrganisationOrganisationidAccountNumbersActiveProductsQueryOptions(organisationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetTerminalOrganisationidAccountNumbersActiveProductsHook = () => {
        const getTerminalOrganisationidAccountNumbersActiveProducts = useMutator<AccountNumberDto[]>();

        return useCallback((
    organisationId: string,
 signal?: AbortSignal
) => {
        return getTerminalOrganisationidAccountNumbersActiveProducts(
          {url: `/api/v2/terminal/${organisationId}/account-numbers-active-products`, method: 'GET', signal
    },
          );
        }, [getTerminalOrganisationidAccountNumbersActiveProducts])
      }
    

export const getGetTerminalOrganisationidAccountNumbersActiveProductsQueryKey = (organisationId?: string,) => {
    return [`/api/v2/terminal/${organisationId}/account-numbers-active-products`] as const;
    }

    
export const useGetTerminalOrganisationidAccountNumbersActiveProductsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTerminalOrganisationidAccountNumbersActiveProductsQueryKey(organisationId);

  const getTerminalOrganisationidAccountNumbersActiveProducts =  useGetTerminalOrganisationidAccountNumbersActiveProductsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>> = ({ signal }) => getTerminalOrganisationidAccountNumbersActiveProducts(organisationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organisationId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTerminalOrganisationidAccountNumbersActiveProductsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>>
export type GetTerminalOrganisationidAccountNumbersActiveProductsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetTerminalOrganisationidAccountNumbersActiveProducts<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTerminalOrganisationidAccountNumbersActiveProducts<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTerminalOrganisationidAccountNumbersActiveProducts<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTerminalOrganisationidAccountNumbersActiveProducts<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationidAccountNumbersActiveProductsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTerminalOrganisationidAccountNumbersActiveProductsQueryOptions(organisationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePutOrganisationIdAccountNumbersAccountnumberHook = () => {
        const putOrganisationIdAccountNumbersAccountnumber = useMutator<null>();

        return useCallback((
    id: string,
    accountNumber: string,
    accountNumberDto: AccountNumberDto,
 ) => {
        return putOrganisationIdAccountNumbersAccountnumber(
          {url: `/api/v2/organisation/${id}/account-numbers/${accountNumber}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: accountNumberDto
    },
          );
        }, [putOrganisationIdAccountNumbersAccountnumber])
      }
    


export const usePutOrganisationIdAccountNumbersAccountnumberMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutOrganisationIdAccountNumbersAccountnumberHook>>>, TError,{id: string;accountNumber: string;data: AccountNumberDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutOrganisationIdAccountNumbersAccountnumberHook>>>, TError,{id: string;accountNumber: string;data: AccountNumberDto}, TContext> => {

const mutationKey = ['putOrganisationIdAccountNumbersAccountnumber'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const putOrganisationIdAccountNumbersAccountnumber =  usePutOrganisationIdAccountNumbersAccountnumberHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePutOrganisationIdAccountNumbersAccountnumberHook>>>, {id: string;accountNumber: string;data: AccountNumberDto}> = (props) => {
          const {id,accountNumber,data} = props ?? {};

          return  putOrganisationIdAccountNumbersAccountnumber(id,accountNumber,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PutOrganisationIdAccountNumbersAccountnumberMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePutOrganisationIdAccountNumbersAccountnumberHook>>>>
    export type PutOrganisationIdAccountNumbersAccountnumberMutationBody = AccountNumberDto
    export type PutOrganisationIdAccountNumbersAccountnumberMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const usePutOrganisationIdAccountNumbersAccountnumber = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePutOrganisationIdAccountNumbersAccountnumberHook>>>, TError,{id: string;accountNumber: string;data: AccountNumberDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePutOrganisationIdAccountNumbersAccountnumberHook>>>,
        TError,
        {id: string;accountNumber: string;data: AccountNumberDto},
        TContext
      > => {

      const mutationOptions = usePutOrganisationIdAccountNumbersAccountnumberMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteAccountNumberForOrganisationHook = () => {
        const deleteAccountNumberForOrganisation = useMutator<null>();

        return useCallback((
    id: string,
    accountNumber: string,
 ) => {
        return deleteAccountNumberForOrganisation(
          {url: `/api/v2/organisation/${id}/account-numbers/${accountNumber}`, method: 'DELETE'
    },
          );
        }, [deleteAccountNumberForOrganisation])
      }
    


export const useDeleteAccountNumberForOrganisationMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForOrganisationHook>>>, TError,{id: string;accountNumber: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForOrganisationHook>>>, TError,{id: string;accountNumber: string}, TContext> => {

const mutationKey = ['deleteAccountNumberForOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteAccountNumberForOrganisation =  useDeleteAccountNumberForOrganisationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForOrganisationHook>>>, {id: string;accountNumber: string}> = (props) => {
          const {id,accountNumber} = props ?? {};

          return  deleteAccountNumberForOrganisation(id,accountNumber,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountNumberForOrganisationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForOrganisationHook>>>>
    
    export type DeleteAccountNumberForOrganisationMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteAccountNumberForOrganisation = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForOrganisationHook>>>, TError,{id: string;accountNumber: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForOrganisationHook>>>,
        TError,
        {id: string;accountNumber: string},
        TContext
      > => {

      const mutationOptions = useDeleteAccountNumberForOrganisationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useListReturnHubsHook = () => {
        const listReturnHubs = useMutator<ReturnHub[]>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return listReturnHubs(
          {url: `/api/v2/return-hubs`, method: 'GET', signal
    },
          );
        }, [listReturnHubs])
      }
    

export const getListReturnHubsQueryKey = () => {
    return [`/api/v2/return-hubs`] as const;
    }

    
export const useListReturnHubsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListReturnHubsQueryKey();

  const listReturnHubs =  useListReturnHubsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>> = ({ signal }) => listReturnHubs(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListReturnHubsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>>
export type ListReturnHubsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useListReturnHubs<TData = Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReturnHubs<TData = Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListReturnHubs<TData = Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListReturnHubs<TData = Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListReturnHubsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListReturnHubsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateReturnHubHook = () => {
        const updateReturnHub = useMutator<ReturnHubResponse>();

        return useCallback((
    returnHub: ReturnHub,
 ) => {
        return updateReturnHub(
          {url: `/api/v2/return-hubs`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: returnHub
    },
          );
        }, [updateReturnHub])
      }
    


export const useUpdateReturnHubMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubHook>>>, TError,{data: ReturnHub}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubHook>>>, TError,{data: ReturnHub}, TContext> => {

const mutationKey = ['updateReturnHub'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateReturnHub =  useUpdateReturnHubHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubHook>>>, {data: ReturnHub}> = (props) => {
          const {data} = props ?? {};

          return  updateReturnHub(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateReturnHubMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubHook>>>>
    export type UpdateReturnHubMutationBody = ReturnHub
    export type UpdateReturnHubMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdateReturnHub = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubHook>>>, TError,{data: ReturnHub}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubHook>>>,
        TError,
        {data: ReturnHub},
        TContext
      > => {

      const mutationOptions = useUpdateReturnHubMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useCreateReturnHubHook = () => {
        const createReturnHub = useMutator<ReturnHubResponse>();

        return useCallback((
    newReturnHub: NewReturnHub,
 signal?: AbortSignal
) => {
        return createReturnHub(
          {url: `/api/v2/return-hubs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newReturnHub, signal
    },
          );
        }, [createReturnHub])
      }
    


export const useCreateReturnHubMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnHubHook>>>, TError,{data: NewReturnHub}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnHubHook>>>, TError,{data: NewReturnHub}, TContext> => {

const mutationKey = ['createReturnHub'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createReturnHub =  useCreateReturnHubHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateReturnHubHook>>>, {data: NewReturnHub}> = (props) => {
          const {data} = props ?? {};

          return  createReturnHub(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateReturnHubMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateReturnHubHook>>>>
    export type CreateReturnHubMutationBody = NewReturnHub
    export type CreateReturnHubMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreateReturnHub = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnHubHook>>>, TError,{data: NewReturnHub}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateReturnHubHook>>>,
        TError,
        {data: NewReturnHub},
        TContext
      > => {

      const mutationOptions = useCreateReturnHubMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetReturnHubHook = () => {
        const getReturnHub = useMutator<ReturnHub>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {
        return getReturnHub(
          {url: `/api/v2/return-hubs/${id}`, method: 'GET', signal
    },
          );
        }, [getReturnHub])
      }
    

export const getGetReturnHubQueryKey = (id?: string,) => {
    return [`/api/v2/return-hubs/${id}`] as const;
    }

    
export const useGetReturnHubQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReturnHubQueryKey(id);

  const getReturnHub =  useGetReturnHubHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>> = ({ signal }) => getReturnHub(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReturnHubQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>>
export type GetReturnHubQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetReturnHub<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReturnHub<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReturnHub<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReturnHub<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetReturnHubQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useDeleteReturnHubHook = () => {
        const deleteReturnHub = useMutator<SuccessResponse>();

        return useCallback((
    id: string,
 ) => {
        return deleteReturnHub(
          {url: `/api/v2/return-hubs/${id}`, method: 'DELETE'
    },
          );
        }, [deleteReturnHub])
      }
    


export const useDeleteReturnHubMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubHook>>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubHook>>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteReturnHub'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteReturnHub =  useDeleteReturnHubHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteReturnHub(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteReturnHubMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubHook>>>>
    
    export type DeleteReturnHubMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteReturnHub = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubHook>>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteReturnHubMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useUpdateReturnHubLinkHook = () => {
        const updateReturnHubLink = useMutator<UpdateReturnHubLinkResponse>();

        return useCallback((
    returnHubLink: ReturnHubLink,
 ) => {
        return updateReturnHubLink(
          {url: `/api/v2/return-hub-links`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: returnHubLink
    },
          );
        }, [updateReturnHubLink])
      }
    


export const useUpdateReturnHubLinkMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubLinkHook>>>, TError,{data: ReturnHubLink}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubLinkHook>>>, TError,{data: ReturnHubLink}, TContext> => {

const mutationKey = ['updateReturnHubLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateReturnHubLink =  useUpdateReturnHubLinkHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubLinkHook>>>, {data: ReturnHubLink}> = (props) => {
          const {data} = props ?? {};

          return  updateReturnHubLink(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateReturnHubLinkMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubLinkHook>>>>
    export type UpdateReturnHubLinkMutationBody = ReturnHubLink
    export type UpdateReturnHubLinkMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdateReturnHubLink = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubLinkHook>>>, TError,{data: ReturnHubLink}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateReturnHubLinkHook>>>,
        TError,
        {data: ReturnHubLink},
        TContext
      > => {

      const mutationOptions = useUpdateReturnHubLinkMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useCreateReturnHubLinkHook = () => {
        const createReturnHubLink = useMutator<null>();

        return useCallback((
    returnHubLink: ReturnHubLink,
 signal?: AbortSignal
) => {
        return createReturnHubLink(
          {url: `/api/v2/return-hub-links`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: returnHubLink, signal
    },
          );
        }, [createReturnHubLink])
      }
    


export const useCreateReturnHubLinkMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnHubLinkHook>>>, TError,{data: ReturnHubLink}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnHubLinkHook>>>, TError,{data: ReturnHubLink}, TContext> => {

const mutationKey = ['createReturnHubLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createReturnHubLink =  useCreateReturnHubLinkHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateReturnHubLinkHook>>>, {data: ReturnHubLink}> = (props) => {
          const {data} = props ?? {};

          return  createReturnHubLink(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateReturnHubLinkMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateReturnHubLinkHook>>>>
    export type CreateReturnHubLinkMutationBody = ReturnHubLink
    export type CreateReturnHubLinkMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreateReturnHubLink = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateReturnHubLinkHook>>>, TError,{data: ReturnHubLink}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateReturnHubLinkHook>>>,
        TError,
        {data: ReturnHubLink},
        TContext
      > => {

      const mutationOptions = useCreateReturnHubLinkMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetReturnHubLinkHook = () => {
        const getReturnHubLink = useMutator<ReturnHubLink>();

        return useCallback((
    accountNumber: string,
    product: string,
 signal?: AbortSignal
) => {
        return getReturnHubLink(
          {url: `/api/v2/return-hub-links/${accountNumber}/${product}`, method: 'GET', signal
    },
          );
        }, [getReturnHubLink])
      }
    

export const getGetReturnHubLinkQueryKey = (accountNumber?: string,
    product?: string,) => {
    return [`/api/v2/return-hub-links/${accountNumber}/${product}`] as const;
    }

    
export const useGetReturnHubLinkQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(accountNumber: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetReturnHubLinkQueryKey(accountNumber,product);

  const getReturnHubLink =  useGetReturnHubLinkHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>> = ({ signal }) => getReturnHubLink(accountNumber,product, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(accountNumber && product),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetReturnHubLinkQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>>
export type GetReturnHubLinkQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetReturnHubLink<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 accountNumber: string,
    product: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReturnHubLink<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 accountNumber: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetReturnHubLink<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 accountNumber: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetReturnHubLink<TData = Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 accountNumber: string,
    product: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnHubLinkHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetReturnHubLinkQueryOptions(accountNumber,product,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useDeleteReturnHubLinkHook = () => {
        const deleteReturnHubLink = useMutator<SuccessResponse>();

        return useCallback((
    accountNumber: string,
    product: string,
 ) => {
        return deleteReturnHubLink(
          {url: `/api/v2/return-hub-links/${accountNumber}/${product}`, method: 'DELETE'
    },
          );
        }, [deleteReturnHubLink])
      }
    


export const useDeleteReturnHubLinkMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubLinkHook>>>, TError,{accountNumber: string;product: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubLinkHook>>>, TError,{accountNumber: string;product: string}, TContext> => {

const mutationKey = ['deleteReturnHubLink'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteReturnHubLink =  useDeleteReturnHubLinkHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubLinkHook>>>, {accountNumber: string;product: string}> = (props) => {
          const {accountNumber,product} = props ?? {};

          return  deleteReturnHubLink(accountNumber,product,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteReturnHubLinkMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubLinkHook>>>>
    
    export type DeleteReturnHubLinkMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteReturnHubLink = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubLinkHook>>>, TError,{accountNumber: string;product: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteReturnHubLinkHook>>>,
        TError,
        {accountNumber: string;product: string},
        TContext
      > => {

      const mutationOptions = useDeleteReturnHubLinkMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Get a user for admin
 */
export const useGetUserHook = () => {
        const getUser = useMutator<UserDto>();

        return useCallback((
    emailOrId: string,
 signal?: AbortSignal
) => {
        return getUser(
          {url: `/api/v2/users/${emailOrId}`, method: 'GET', signal
    },
          );
        }, [getUser])
      }
    

export const getGetUserQueryKey = (emailOrId?: string,) => {
    return [`/api/v2/users/${emailOrId}`] as const;
    }

    
export const useGetUserQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserQueryKey(emailOrId);

  const getUser =  useGetUserHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>> = ({ signal }) => getUser(emailOrId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(emailOrId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>>
export type GetUserQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetUser<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUser<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUser<TData = Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserQueryOptions(emailOrId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update a user from admin
 */
export const useUpdateUserHook = () => {
        const updateUser = useMutator<null>();

        return useCallback((
    emailOrId: string,
    minimalUserDto: MinimalUserDto,
 ) => {
        return updateUser(
          {url: `/api/v2/users/${emailOrId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: minimalUserDto
    },
          );
        }, [updateUser])
      }
    


export const useUpdateUserMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>, TError,{emailOrId: string;data: MinimalUserDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>, TError,{emailOrId: string;data: MinimalUserDto}, TContext> => {

const mutationKey = ['updateUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateUser =  useUpdateUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>, {emailOrId: string;data: MinimalUserDto}> = (props) => {
          const {emailOrId,data} = props ?? {};

          return  updateUser(emailOrId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>>
    export type UpdateUserMutationBody = MinimalUserDto
    export type UpdateUserMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdateUser = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>, TError,{emailOrId: string;data: MinimalUserDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateUserHook>>>,
        TError,
        {emailOrId: string;data: MinimalUserDto},
        TContext
      > => {

      const mutationOptions = useUpdateUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Get a list of users for admin
 */
export const useGetUsersHook = () => {
        const getUsers = useMutator<PageUserDto>();

        return useCallback((
    params?: GetUsersParams,
 signal?: AbortSignal
) => {
        return getUsers(
          {url: `/api/v2/users`, method: 'GET',
        params, signal
    },
          );
        }, [getUsers])
      }
    

export const getGetUsersQueryKey = (params?: GetUsersParams,) => {
    return [`/api/v2/users`, ...(params ? [params]: [])] as const;
    }

    
export const useGetUsersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersQueryKey(params);

  const getUsers =  useGetUsersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>> = ({ signal }) => getUsers(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>>
export type GetUsersQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUsersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUsersQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a minimal user from admin
 */
export const useCreateUserHook = () => {
        const createUser = useMutator<UserDto>();

        return useCallback((
    minimalUserDto: MinimalUserDto,
 signal?: AbortSignal
) => {
        return createUser(
          {url: `/api/v2/users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: minimalUserDto, signal
    },
          );
        }, [createUser])
      }
    


export const useCreateUserMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>, TError,{data: MinimalUserDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>, TError,{data: MinimalUserDto}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createUser =  useCreateUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>, {data: MinimalUserDto}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>>
    export type CreateUserMutationBody = MinimalUserDto
    export type CreateUserMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreateUser = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>, TError,{data: MinimalUserDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateUserHook>>>,
        TError,
        {data: MinimalUserDto},
        TContext
      > => {

      const mutationOptions = useCreateUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Get all users for an organisation
 */
export const useGetOrganisationUsersHook = () => {
        const getOrganisationUsers = useMutator<UserDto[]>();

        return useCallback((
    organisationId: string,
 signal?: AbortSignal
) => {
        return getOrganisationUsers(
          {url: `/api/v2/organisation/${organisationId}/users`, method: 'GET', signal
    },
          );
        }, [getOrganisationUsers])
      }
    

export const getGetOrganisationUsersQueryKey = (organisationId?: string,) => {
    return [`/api/v2/organisation/${organisationId}/users`] as const;
    }

    
export const useGetOrganisationUsersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganisationUsersQueryKey(organisationId);

  const getOrganisationUsers =  useGetOrganisationUsersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>> = ({ signal }) => getOrganisationUsers(organisationId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(organisationId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganisationUsersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>>
export type GetOrganisationUsersQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetOrganisationUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganisationUsers<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 organisationId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationUsersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOrganisationUsersQueryOptions(organisationId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete user from admin
 */
export const useDeleteUserHook = () => {
        const deleteUser = useMutator<null>();

        return useCallback((
    emailOrId: string,
 ) => {
        return deleteUser(
          {url: `/api/v2/users/${emailOrId}/ghost-user`, method: 'DELETE'
    },
          );
        }, [deleteUser])
      }
    


export const useDeleteUserMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>, TError,{emailOrId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>, TError,{emailOrId: string}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteUser =  useDeleteUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>, {emailOrId: string}> = (props) => {
          const {emailOrId} = props ?? {};

          return  deleteUser(emailOrId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>>
    
    export type DeleteUserMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteUser = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>, TError,{emailOrId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteUserHook>>>,
        TError,
        {emailOrId: string},
        TContext
      > => {

      const mutationOptions = useDeleteUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Get user account numbers by e-mail or id, for admin
 */
export const useGetUserAccountNumbersHook = () => {
        const getUserAccountNumbers = useMutator<string[]>();

        return useCallback((
    emailOrId: string,
 signal?: AbortSignal
) => {
        return getUserAccountNumbers(
          {url: `/api/v2/users/${emailOrId}/account-numbers`, method: 'GET', signal
    },
          );
        }, [getUserAccountNumbers])
      }
    

export const getGetUserAccountNumbersQueryKey = (emailOrId?: string,) => {
    return [`/api/v2/users/${emailOrId}/account-numbers`] as const;
    }

    
export const useGetUserAccountNumbersQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAccountNumbersQueryKey(emailOrId);

  const getUserAccountNumbers =  useGetUserAccountNumbersHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>> = ({ signal }) => getUserAccountNumbers(emailOrId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(emailOrId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserAccountNumbersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>>
export type GetUserAccountNumbersQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetUserAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserAccountNumbers<TData = Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserAccountNumbersHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserAccountNumbersQueryOptions(emailOrId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Adds an account number to a user, for admin
 */
export const useAddUserAccountNumberHook = () => {
        const addUserAccountNumber = useMutator<null>();

        return useCallback((
    emailOrId: string,
    accountNumberDto: AccountNumberDto,
 signal?: AbortSignal
) => {
        return addUserAccountNumber(
          {url: `/api/v2/users/${emailOrId}/account-numbers`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: accountNumberDto, signal
    },
          );
        }, [addUserAccountNumber])
      }
    


export const useAddUserAccountNumberMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddUserAccountNumberHook>>>, TError,{emailOrId: string;data: AccountNumberDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddUserAccountNumberHook>>>, TError,{emailOrId: string;data: AccountNumberDto}, TContext> => {

const mutationKey = ['addUserAccountNumber'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const addUserAccountNumber =  useAddUserAccountNumberHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAddUserAccountNumberHook>>>, {emailOrId: string;data: AccountNumberDto}> = (props) => {
          const {emailOrId,data} = props ?? {};

          return  addUserAccountNumber(emailOrId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddUserAccountNumberMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAddUserAccountNumberHook>>>>
    export type AddUserAccountNumberMutationBody = AccountNumberDto
    export type AddUserAccountNumberMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useAddUserAccountNumber = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddUserAccountNumberHook>>>, TError,{emailOrId: string;data: AccountNumberDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAddUserAccountNumberHook>>>,
        TError,
        {emailOrId: string;data: AccountNumberDto},
        TContext
      > => {

      const mutationOptions = useAddUserAccountNumberMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Remove an account number for a user, for admin
 */
export const useDeleteUserAccountNumberHook = () => {
        const deleteUserAccountNumber = useMutator<null>();

        return useCallback((
    emailOrId: string,
    accountNumber: string,
 ) => {
        return deleteUserAccountNumber(
          {url: `/api/v2/users/${emailOrId}/account-numbers/${accountNumber}`, method: 'DELETE'
    },
          );
        }, [deleteUserAccountNumber])
      }
    


export const useDeleteUserAccountNumberMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserAccountNumberHook>>>, TError,{emailOrId: string;accountNumber: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserAccountNumberHook>>>, TError,{emailOrId: string;accountNumber: string}, TContext> => {

const mutationKey = ['deleteUserAccountNumber'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteUserAccountNumber =  useDeleteUserAccountNumberHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteUserAccountNumberHook>>>, {emailOrId: string;accountNumber: string}> = (props) => {
          const {emailOrId,accountNumber} = props ?? {};

          return  deleteUserAccountNumber(emailOrId,accountNumber,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserAccountNumberMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteUserAccountNumberHook>>>>
    
    export type DeleteUserAccountNumberMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteUserAccountNumber = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserAccountNumberHook>>>, TError,{emailOrId: string;accountNumber: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteUserAccountNumberHook>>>,
        TError,
        {emailOrId: string;accountNumber: string},
        TContext
      > => {

      const mutationOptions = useDeleteUserAccountNumberMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Get user Roles by e-mail or id, for admin
 */
export const useGetUserRolesHook = () => {
        const getUserRoles = useMutator<RoleNameDto[]>();

        return useCallback((
    emailOrId: string,
 signal?: AbortSignal
) => {
        return getUserRoles(
          {url: `/api/v2/users/${emailOrId}/roles`, method: 'GET', signal
    },
          );
        }, [getUserRoles])
      }
    

export const getGetUserRolesQueryKey = (emailOrId?: string,) => {
    return [`/api/v2/users/${emailOrId}/roles`] as const;
    }

    
export const useGetUserRolesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserRolesQueryKey(emailOrId);

  const getUserRoles =  useGetUserRolesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>> = ({ signal }) => getUserRoles(emailOrId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(emailOrId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUserRolesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>>
export type GetUserRolesQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetUserRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUserRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUserRoles<TData = Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetUserRolesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetUserRolesQueryOptions(emailOrId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update user roles, from admin
 */
export const useUpdateUserRolesHook = () => {
        const updateUserRoles = useMutator<null>();

        return useCallback((
    emailOrId: string,
    roleNameDto?: RoleNameDto[],
 ) => {
        return updateUserRoles(
          {url: `/api/v2/users/${emailOrId}/roles`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: roleNameDto
    },
          );
        }, [updateUserRoles])
      }
    


export const useUpdateUserRolesMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserRolesHook>>>, TError,{emailOrId: string;data: RoleNameDto[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserRolesHook>>>, TError,{emailOrId: string;data: RoleNameDto[]}, TContext> => {

const mutationKey = ['updateUserRoles'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateUserRoles =  useUpdateUserRolesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateUserRolesHook>>>, {emailOrId: string;data: RoleNameDto[]}> = (props) => {
          const {emailOrId,data} = props ?? {};

          return  updateUserRoles(emailOrId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserRolesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateUserRolesHook>>>>
    export type UpdateUserRolesMutationBody = RoleNameDto[]
    export type UpdateUserRolesMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdateUserRoles = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserRolesHook>>>, TError,{emailOrId: string;data: RoleNameDto[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateUserRolesHook>>>,
        TError,
        {emailOrId: string;data: RoleNameDto[]},
        TContext
      > => {

      const mutationOptions = useUpdateUserRolesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Create a parcel shop user
 */
export const useCreateParcelShopUserHook = () => {
        const createParcelShopUser = useMutator<null>();

        return useCallback((
    parcelShopManagerRequestDto: ParcelShopManagerRequestDto,
 signal?: AbortSignal
) => {
        return createParcelShopUser(
          {url: `/api/v2/parcel-shop-users`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: parcelShopManagerRequestDto, signal
    },
          );
        }, [createParcelShopUser])
      }
    


export const useCreateParcelShopUserMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateParcelShopUserHook>>>, TError,{data: ParcelShopManagerRequestDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateParcelShopUserHook>>>, TError,{data: ParcelShopManagerRequestDto}, TContext> => {

const mutationKey = ['createParcelShopUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createParcelShopUser =  useCreateParcelShopUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateParcelShopUserHook>>>, {data: ParcelShopManagerRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  createParcelShopUser(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateParcelShopUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateParcelShopUserHook>>>>
    export type CreateParcelShopUserMutationBody = ParcelShopManagerRequestDto
    export type CreateParcelShopUserMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreateParcelShopUser = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateParcelShopUserHook>>>, TError,{data: ParcelShopManagerRequestDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateParcelShopUserHook>>>,
        TError,
        {data: ParcelShopManagerRequestDto},
        TContext
      > => {

      const mutationOptions = useCreateParcelShopUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Create an auth token, for admin
 */
export const useCreateAuthTokenHook = () => {
        const createAuthToken = useMutator<CreateAuthTokenResponseDto>();

        return useCallback((
    createAuthTokenDto: CreateAuthTokenDto,
 signal?: AbortSignal
) => {
        return createAuthToken(
          {url: `/api/v2/users/auth-token`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAuthTokenDto, signal
    },
          );
        }, [createAuthToken])
      }
    


export const useCreateAuthTokenMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateAuthTokenHook>>>, TError,{data: CreateAuthTokenDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateAuthTokenHook>>>, TError,{data: CreateAuthTokenDto}, TContext> => {

const mutationKey = ['createAuthToken'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createAuthToken =  useCreateAuthTokenHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateAuthTokenHook>>>, {data: CreateAuthTokenDto}> = (props) => {
          const {data} = props ?? {};

          return  createAuthToken(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateAuthTokenMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateAuthTokenHook>>>>
    export type CreateAuthTokenMutationBody = CreateAuthTokenDto
    export type CreateAuthTokenMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreateAuthToken = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateAuthTokenHook>>>, TError,{data: CreateAuthTokenDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateAuthTokenHook>>>,
        TError,
        {data: CreateAuthTokenDto},
        TContext
      > => {

      const mutationOptions = useCreateAuthTokenMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useUpdateUserTypeHook = () => {
        const updateUserType = useMutator<null>();

        return useCallback((
    id: string,
    userType: UserType,
 ) => {
        return updateUserType(
          {url: `/api/v2/users/${id}/userType/${userType}`, method: 'PUT'
    },
          );
        }, [updateUserType])
      }
    


export const useUpdateUserTypeMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserTypeHook>>>, TError,{id: string;userType: UserType}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserTypeHook>>>, TError,{id: string;userType: UserType}, TContext> => {

const mutationKey = ['updateUserType'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateUserType =  useUpdateUserTypeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateUserTypeHook>>>, {id: string;userType: UserType}> = (props) => {
          const {id,userType} = props ?? {};

          return  updateUserType(id,userType,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserTypeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateUserTypeHook>>>>
    
    export type UpdateUserTypeMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdateUserType = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserTypeHook>>>, TError,{id: string;userType: UserType}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateUserTypeHook>>>,
        TError,
        {id: string;userType: UserType},
        TContext
      > => {

      const mutationOptions = useUpdateUserTypeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteAddressBookP1Hook = () => {
        const deleteAddressBookP1 = useMutator<null>();

        return useCallback((
    p1: string,
 ) => {
        return deleteAddressBookP1(
          {url: `/api/v2/address-book/${p1}`, method: 'DELETE'
    },
          );
        }, [deleteAddressBookP1])
      }
    


export const useDeleteAddressBookP1MutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAddressBookP1Hook>>>, TError,{p1: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAddressBookP1Hook>>>, TError,{p1: string}, TContext> => {

const mutationKey = ['deleteAddressBookP1'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteAddressBookP1 =  useDeleteAddressBookP1Hook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteAddressBookP1Hook>>>, {p1: string}> = (props) => {
          const {p1} = props ?? {};

          return  deleteAddressBookP1(p1,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAddressBookP1MutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteAddressBookP1Hook>>>>
    
    export type DeleteAddressBookP1MutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteAddressBookP1 = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAddressBookP1Hook>>>, TError,{p1: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteAddressBookP1Hook>>>,
        TError,
        {p1: string},
        TContext
      > => {

      const mutationOptions = useDeleteAddressBookP1MutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetBusinessUnitHook = () => {
        const getBusinessUnit = useMutator<BusinessUnitDto[]>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getBusinessUnit(
          {url: `/api/v2/business-unit`, method: 'GET', signal
    },
          );
        }, [getBusinessUnit])
      }
    

export const getGetBusinessUnitQueryKey = () => {
    return [`/api/v2/business-unit`] as const;
    }

    
export const useGetBusinessUnitQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessUnitQueryKey();

  const getBusinessUnit =  useGetBusinessUnitHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>> = ({ signal }) => getBusinessUnit(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessUnitQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>>
export type GetBusinessUnitQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetBusinessUnit<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessUnit<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessUnit<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBusinessUnit<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBusinessUnitQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetBusinessUnitCodeHook = () => {
        const getBusinessUnitCode = useMutator<BusinessUnitDto>();

        return useCallback((
    code: string,
 signal?: AbortSignal
) => {
        return getBusinessUnitCode(
          {url: `/api/v2/business-unit/${code}`, method: 'GET', signal
    },
          );
        }, [getBusinessUnitCode])
      }
    

export const getGetBusinessUnitCodeQueryKey = (code?: string,) => {
    return [`/api/v2/business-unit/${code}`] as const;
    }

    
export const useGetBusinessUnitCodeQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBusinessUnitCodeQueryKey(code);

  const getBusinessUnitCode =  useGetBusinessUnitCodeHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>> = ({ signal }) => getBusinessUnitCode(code, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBusinessUnitCodeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>>
export type GetBusinessUnitCodeQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetBusinessUnitCode<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessUnitCode<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBusinessUnitCode<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBusinessUnitCode<TData = Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBusinessUnitCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBusinessUnitCodeQueryOptions(code,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetOrganisationsHook = () => {
        const getOrganisations = useMutator<PageOrganisationDto>();

        return useCallback((
    params?: GetOrganisationsParams,
 signal?: AbortSignal
) => {
        return getOrganisations(
          {url: `/api/v2/organisation`, method: 'GET',
        params, signal
    },
          );
        }, [getOrganisations])
      }
    

export const getGetOrganisationsQueryKey = (params?: GetOrganisationsParams,) => {
    return [`/api/v2/organisation`, ...(params ? [params]: [])] as const;
    }

    
export const useGetOrganisationsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganisationsQueryKey(params);

  const getOrganisations =  useGetOrganisationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>> = ({ signal }) => getOrganisations(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganisationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>>
export type GetOrganisationsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetOrganisationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOrganisationsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useCreateOrganisationHook = () => {
        const createOrganisation = useMutator<OrganisationDto>();

        return useCallback((
    newOrganisationDto: NewOrganisationDto,
 signal?: AbortSignal
) => {
        return createOrganisation(
          {url: `/api/v2/organisation`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newOrganisationDto, signal
    },
          );
        }, [createOrganisation])
      }
    


export const useCreateOrganisationMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>, TError,{data: NewOrganisationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>, TError,{data: NewOrganisationDto}, TContext> => {

const mutationKey = ['createOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createOrganisation =  useCreateOrganisationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>, {data: NewOrganisationDto}> = (props) => {
          const {data} = props ?? {};

          return  createOrganisation(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganisationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>>
    export type CreateOrganisationMutationBody = NewOrganisationDto
    export type CreateOrganisationMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreateOrganisation = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>, TError,{data: NewOrganisationDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateOrganisationHook>>>,
        TError,
        {data: NewOrganisationDto},
        TContext
      > => {

      const mutationOptions = useCreateOrganisationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetOrganisationHook = () => {
        const getOrganisation = useMutator<OrganisationDto>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {
        return getOrganisation(
          {url: `/api/v2/organisation/${id}`, method: 'GET', signal
    },
          );
        }, [getOrganisation])
      }
    

export const getGetOrganisationQueryKey = (id?: string,) => {
    return [`/api/v2/organisation/${id}`] as const;
    }

    
export const useGetOrganisationQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganisationQueryKey(id);

  const getOrganisation =  useGetOrganisationHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>> = ({ signal }) => getOrganisation(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganisationQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>>
export type GetOrganisationQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetOrganisation<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisation<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisation<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganisation<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOrganisationQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateOrganisationHook = () => {
        const updateOrganisation = useMutator<OrganisationDto>();

        return useCallback((
    id: string,
    organisationDto: OrganisationDto,
 ) => {
        return updateOrganisation(
          {url: `/api/v2/organisation/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: organisationDto
    },
          );
        }, [updateOrganisation])
      }
    


export const useUpdateOrganisationMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>, TError,{id: string;data: OrganisationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>, TError,{id: string;data: OrganisationDto}, TContext> => {

const mutationKey = ['updateOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateOrganisation =  useUpdateOrganisationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>, {id: string;data: OrganisationDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateOrganisation(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganisationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>>
    export type UpdateOrganisationMutationBody = OrganisationDto
    export type UpdateOrganisationMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdateOrganisation = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>, TError,{id: string;data: OrganisationDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationHook>>>,
        TError,
        {id: string;data: OrganisationDto},
        TContext
      > => {

      const mutationOptions = useUpdateOrganisationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetOrganisationIntegratorsHook = () => {
        const getOrganisationIntegrators = useMutator<OrganisationCccIntegratorDto[]>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {
        return getOrganisationIntegrators(
          {url: `/api/v2/organisation/${id}/ccc/integrator`, method: 'GET', signal
    },
          );
        }, [getOrganisationIntegrators])
      }
    

export const getGetOrganisationIntegratorsQueryKey = (id?: string,) => {
    return [`/api/v2/organisation/${id}/ccc/integrator`] as const;
    }

    
export const useGetOrganisationIntegratorsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganisationIntegratorsQueryKey(id);

  const getOrganisationIntegrators =  useGetOrganisationIntegratorsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>> = ({ signal }) => getOrganisationIntegrators(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganisationIntegratorsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>>
export type GetOrganisationIntegratorsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetOrganisationIntegrators<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationIntegrators<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationIntegrators<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganisationIntegrators<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationIntegratorsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOrganisationIntegratorsQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useCreateOrganisationIntegratorHook = () => {
        const createOrganisationIntegrator = useMutator<null>();

        return useCallback((
    id: string,
    organisationCccIntegratorDto: OrganisationCccIntegratorDto,
 signal?: AbortSignal
) => {
        return createOrganisationIntegrator(
          {url: `/api/v2/organisation/${id}/ccc/integrator`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: organisationCccIntegratorDto, signal
    },
          );
        }, [createOrganisationIntegrator])
      }
    


export const useCreateOrganisationIntegratorMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateOrganisationIntegratorHook>>>, TError,{id: string;data: OrganisationCccIntegratorDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateOrganisationIntegratorHook>>>, TError,{id: string;data: OrganisationCccIntegratorDto}, TContext> => {

const mutationKey = ['createOrganisationIntegrator'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createOrganisationIntegrator =  useCreateOrganisationIntegratorHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateOrganisationIntegratorHook>>>, {id: string;data: OrganisationCccIntegratorDto}> = (props) => {
          const {id,data} = props ?? {};

          return  createOrganisationIntegrator(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateOrganisationIntegratorMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateOrganisationIntegratorHook>>>>
    export type CreateOrganisationIntegratorMutationBody = OrganisationCccIntegratorDto
    export type CreateOrganisationIntegratorMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreateOrganisationIntegrator = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateOrganisationIntegratorHook>>>, TError,{id: string;data: OrganisationCccIntegratorDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateOrganisationIntegratorHook>>>,
        TError,
        {id: string;data: OrganisationCccIntegratorDto},
        TContext
      > => {

      const mutationOptions = useCreateOrganisationIntegratorMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetOrganisationCCCApiCredentialsHook = () => {
        const getOrganisationCCCApiCredentials = useMutator<ClientAuthenticationDto>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {
        return getOrganisationCCCApiCredentials(
          {url: `/api/v2/organisation/${id}/ccc/ccc-api-credentials`, method: 'GET', signal
    },
          );
        }, [getOrganisationCCCApiCredentials])
      }
    

export const getGetOrganisationCCCApiCredentialsQueryKey = (id?: string,) => {
    return [`/api/v2/organisation/${id}/ccc/ccc-api-credentials`] as const;
    }

    
export const useGetOrganisationCCCApiCredentialsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganisationCCCApiCredentialsQueryKey(id);

  const getOrganisationCCCApiCredentials =  useGetOrganisationCCCApiCredentialsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>> = ({ signal }) => getOrganisationCCCApiCredentials(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganisationCCCApiCredentialsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>>
export type GetOrganisationCCCApiCredentialsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetOrganisationCCCApiCredentials<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationCCCApiCredentials<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationCCCApiCredentials<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganisationCCCApiCredentials<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationCCCApiCredentialsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOrganisationCCCApiCredentialsQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetOrganisationForUserHook = () => {
        const getOrganisationForUser = useMutator<OrganisationDto | null>();

        return useCallback((
    emailOrId: string,
 signal?: AbortSignal
) => {
        return getOrganisationForUser(
          {url: `/api/v2/users/${emailOrId}/organisation`, method: 'GET', signal
    },
          );
        }, [getOrganisationForUser])
      }
    

export const getGetOrganisationForUserQueryKey = (emailOrId?: string,) => {
    return [`/api/v2/users/${emailOrId}/organisation`] as const;
    }

    
export const useGetOrganisationForUserQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganisationForUserQueryKey(emailOrId);

  const getOrganisationForUser =  useGetOrganisationForUserHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>> = ({ signal }) => getOrganisationForUser(emailOrId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(emailOrId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganisationForUserQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>>
export type GetOrganisationForUserQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetOrganisationForUser<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationForUser<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationForUser<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganisationForUser<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 emailOrId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationForUserHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOrganisationForUserQueryOptions(emailOrId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetAccountManagersByOrganisationHook = () => {
        const getAccountManagersByOrganisation = useMutator<PageUserDto>();

        return useCallback((
    id: string,
    params?: GetAccountManagersByOrganisationParams,
 signal?: AbortSignal
) => {
        return getAccountManagersByOrganisation(
          {url: `/api/v2/organisation/${id}/account-managers`, method: 'GET',
        params, signal
    },
          );
        }, [getAccountManagersByOrganisation])
      }
    

export const getGetAccountManagersByOrganisationQueryKey = (id?: string,
    params?: GetAccountManagersByOrganisationParams,) => {
    return [`/api/v2/organisation/${id}/account-managers`, ...(params ? [params]: [])] as const;
    }

    
export const useGetAccountManagersByOrganisationQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(id: string,
    params?: GetAccountManagersByOrganisationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAccountManagersByOrganisationQueryKey(id,params);

  const getAccountManagersByOrganisation =  useGetAccountManagersByOrganisationHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>> = ({ signal }) => getAccountManagersByOrganisation(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAccountManagersByOrganisationQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>>
export type GetAccountManagersByOrganisationQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetAccountManagersByOrganisation<TData = Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string,
    params: undefined |  GetAccountManagersByOrganisationParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagersByOrganisation<TData = Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string,
    params?: GetAccountManagersByOrganisationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAccountManagersByOrganisation<TData = Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string,
    params?: GetAccountManagersByOrganisationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAccountManagersByOrganisation<TData = Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string,
    params?: GetAccountManagersByOrganisationParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetAccountManagersByOrganisationHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetAccountManagersByOrganisationQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useAddOrganisationAccountManagersHook = () => {
        const addOrganisationAccountManagers = useMutator<null>();

        return useCallback((
    id: string,
    addAccountManagersToOrganizationDto: AddAccountManagersToOrganizationDto,
 ) => {
        return addOrganisationAccountManagers(
          {url: `/api/v2/organisation/${id}/account-managers`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: addAccountManagersToOrganizationDto
    },
          );
        }, [addOrganisationAccountManagers])
      }
    


export const useAddOrganisationAccountManagersMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddOrganisationAccountManagersHook>>>, TError,{id: string;data: AddAccountManagersToOrganizationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddOrganisationAccountManagersHook>>>, TError,{id: string;data: AddAccountManagersToOrganizationDto}, TContext> => {

const mutationKey = ['addOrganisationAccountManagers'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const addOrganisationAccountManagers =  useAddOrganisationAccountManagersHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAddOrganisationAccountManagersHook>>>, {id: string;data: AddAccountManagersToOrganizationDto}> = (props) => {
          const {id,data} = props ?? {};

          return  addOrganisationAccountManagers(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AddOrganisationAccountManagersMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAddOrganisationAccountManagersHook>>>>
    export type AddOrganisationAccountManagersMutationBody = AddAccountManagersToOrganizationDto
    export type AddOrganisationAccountManagersMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useAddOrganisationAccountManagers = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAddOrganisationAccountManagersHook>>>, TError,{id: string;data: AddAccountManagersToOrganizationDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAddOrganisationAccountManagersHook>>>,
        TError,
        {id: string;data: AddAccountManagersToOrganizationDto},
        TContext
      > => {

      const mutationOptions = useAddOrganisationAccountManagersMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetOrganisationsByAcccountManagerHook = () => {
        const getOrganisationsByAcccountManager = useMutator<PageOrganisationDto>();

        return useCallback((
    id: string,
    params?: GetOrganisationsByAcccountManagerParams,
 signal?: AbortSignal
) => {
        return getOrganisationsByAcccountManager(
          {url: `/api/v2/account-manager/${id}/organisations`, method: 'GET',
        params, signal
    },
          );
        }, [getOrganisationsByAcccountManager])
      }
    

export const getGetOrganisationsByAcccountManagerQueryKey = (id?: string,
    params?: GetOrganisationsByAcccountManagerParams,) => {
    return [`/api/v2/account-manager/${id}/organisations`, ...(params ? [params]: [])] as const;
    }

    
export const useGetOrganisationsByAcccountManagerQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(id: string,
    params?: GetOrganisationsByAcccountManagerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrganisationsByAcccountManagerQueryKey(id,params);

  const getOrganisationsByAcccountManager =  useGetOrganisationsByAcccountManagerHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>> = ({ signal }) => getOrganisationsByAcccountManager(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetOrganisationsByAcccountManagerQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>>
export type GetOrganisationsByAcccountManagerQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetOrganisationsByAcccountManager<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string,
    params: undefined |  GetOrganisationsByAcccountManagerParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationsByAcccountManager<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string,
    params?: GetOrganisationsByAcccountManagerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetOrganisationsByAcccountManager<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string,
    params?: GetOrganisationsByAcccountManagerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetOrganisationsByAcccountManager<TData = Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string,
    params?: GetOrganisationsByAcccountManagerParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetOrganisationsByAcccountManagerHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetOrganisationsByAcccountManagerQueryOptions(id,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useAssignOrganisationsToAccountManagerHook = () => {
        const assignOrganisationsToAccountManager = useMutator<null>();

        return useCallback((
    id: string,
    assignOrganisationsToAccountManagerDto: AssignOrganisationsToAccountManagerDto,
 ) => {
        return assignOrganisationsToAccountManager(
          {url: `/api/v2/account-manager/${id}/organisations`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: assignOrganisationsToAccountManagerDto
    },
          );
        }, [assignOrganisationsToAccountManager])
      }
    


export const useAssignOrganisationsToAccountManagerMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAssignOrganisationsToAccountManagerHook>>>, TError,{id: string;data: AssignOrganisationsToAccountManagerDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAssignOrganisationsToAccountManagerHook>>>, TError,{id: string;data: AssignOrganisationsToAccountManagerDto}, TContext> => {

const mutationKey = ['assignOrganisationsToAccountManager'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const assignOrganisationsToAccountManager =  useAssignOrganisationsToAccountManagerHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAssignOrganisationsToAccountManagerHook>>>, {id: string;data: AssignOrganisationsToAccountManagerDto}> = (props) => {
          const {id,data} = props ?? {};

          return  assignOrganisationsToAccountManager(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignOrganisationsToAccountManagerMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAssignOrganisationsToAccountManagerHook>>>>
    export type AssignOrganisationsToAccountManagerMutationBody = AssignOrganisationsToAccountManagerDto
    export type AssignOrganisationsToAccountManagerMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useAssignOrganisationsToAccountManager = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAssignOrganisationsToAccountManagerHook>>>, TError,{id: string;data: AssignOrganisationsToAccountManagerDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAssignOrganisationsToAccountManagerHook>>>,
        TError,
        {id: string;data: AssignOrganisationsToAccountManagerDto},
        TContext
      > => {

      const mutationOptions = useAssignOrganisationsToAccountManagerMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteOrganisationAccountManagerHook = () => {
        const deleteOrganisationAccountManager = useMutator<null>();

        return useCallback((
    id: string,
    userId: string,
 ) => {
        return deleteOrganisationAccountManager(
          {url: `/api/v2/organisation/${id}/account-managers/${userId}`, method: 'DELETE'
    },
          );
        }, [deleteOrganisationAccountManager])
      }
    


export const useDeleteOrganisationAccountManagerMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationAccountManagerHook>>>, TError,{id: string;userId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationAccountManagerHook>>>, TError,{id: string;userId: string}, TContext> => {

const mutationKey = ['deleteOrganisationAccountManager'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteOrganisationAccountManager =  useDeleteOrganisationAccountManagerHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationAccountManagerHook>>>, {id: string;userId: string}> = (props) => {
          const {id,userId} = props ?? {};

          return  deleteOrganisationAccountManager(id,userId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganisationAccountManagerMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationAccountManagerHook>>>>
    
    export type DeleteOrganisationAccountManagerMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteOrganisationAccountManager = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationAccountManagerHook>>>, TError,{id: string;userId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationAccountManagerHook>>>,
        TError,
        {id: string;userId: string},
        TContext
      > => {

      const mutationOptions = useDeleteOrganisationAccountManagerMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useUpdateOrganisationForUserHook = () => {
        const updateOrganisationForUser = useMutator<null>();

        return useCallback((
    emailOrId: string,
    organisationId: string,
 ) => {
        return updateOrganisationForUser(
          {url: `/api/v2/users/${emailOrId}/organisation/${organisationId}`, method: 'PUT'
    },
          );
        }, [updateOrganisationForUser])
      }
    


export const useUpdateOrganisationForUserMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationForUserHook>>>, TError,{emailOrId: string;organisationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationForUserHook>>>, TError,{emailOrId: string;organisationId: string}, TContext> => {

const mutationKey = ['updateOrganisationForUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateOrganisationForUser =  useUpdateOrganisationForUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationForUserHook>>>, {emailOrId: string;organisationId: string}> = (props) => {
          const {emailOrId,organisationId} = props ?? {};

          return  updateOrganisationForUser(emailOrId,organisationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateOrganisationForUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationForUserHook>>>>
    
    export type UpdateOrganisationForUserMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdateOrganisationForUser = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationForUserHook>>>, TError,{emailOrId: string;organisationId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateOrganisationForUserHook>>>,
        TError,
        {emailOrId: string;organisationId: string},
        TContext
      > => {

      const mutationOptions = useUpdateOrganisationForUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteUserFromOrganisationHook = () => {
        const deleteUserFromOrganisation = useMutator<null>();

        return useCallback((
    emailOrId: string,
 ) => {
        return deleteUserFromOrganisation(
          {url: `/api/v2/organisation/user/${emailOrId}`, method: 'DELETE'
    },
          );
        }, [deleteUserFromOrganisation])
      }
    


export const useDeleteUserFromOrganisationMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserFromOrganisationHook>>>, TError,{emailOrId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserFromOrganisationHook>>>, TError,{emailOrId: string}, TContext> => {

const mutationKey = ['deleteUserFromOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteUserFromOrganisation =  useDeleteUserFromOrganisationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteUserFromOrganisationHook>>>, {emailOrId: string}> = (props) => {
          const {emailOrId} = props ?? {};

          return  deleteUserFromOrganisation(emailOrId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserFromOrganisationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteUserFromOrganisationHook>>>>
    
    export type DeleteUserFromOrganisationMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteUserFromOrganisation = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserFromOrganisationHook>>>, TError,{emailOrId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteUserFromOrganisationHook>>>,
        TError,
        {emailOrId: string},
        TContext
      > => {

      const mutationOptions = useDeleteUserFromOrganisationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteOrganisationIntegratorHook = () => {
        const deleteOrganisationIntegrator = useMutator<null>();

        return useCallback((
    id: string,
    integratorId: string,
 ) => {
        return deleteOrganisationIntegrator(
          {url: `/api/v2/organisation/${id}/ccc/integrator/${integratorId}`, method: 'DELETE'
    },
          );
        }, [deleteOrganisationIntegrator])
      }
    


export const useDeleteOrganisationIntegratorMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationIntegratorHook>>>, TError,{id: string;integratorId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationIntegratorHook>>>, TError,{id: string;integratorId: string}, TContext> => {

const mutationKey = ['deleteOrganisationIntegrator'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteOrganisationIntegrator =  useDeleteOrganisationIntegratorHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationIntegratorHook>>>, {id: string;integratorId: string}> = (props) => {
          const {id,integratorId} = props ?? {};

          return  deleteOrganisationIntegrator(id,integratorId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteOrganisationIntegratorMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationIntegratorHook>>>>
    
    export type DeleteOrganisationIntegratorMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteOrganisationIntegrator = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationIntegratorHook>>>, TError,{id: string;integratorId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteOrganisationIntegratorHook>>>,
        TError,
        {id: string;integratorId: string},
        TContext
      > => {

      const mutationOptions = useDeleteOrganisationIntegratorMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetTerminalOrganisationsHook = () => {
        const getTerminalOrganisations = useMutator<PageOrganisationDto>();

        return useCallback((
    params?: GetTerminalOrganisationsParams,
 signal?: AbortSignal
) => {
        return getTerminalOrganisations(
          {url: `/api/v2/terminal`, method: 'GET',
        params, signal
    },
          );
        }, [getTerminalOrganisations])
      }
    

export const getGetTerminalOrganisationsQueryKey = (params?: GetTerminalOrganisationsParams,) => {
    return [`/api/v2/terminal`, ...(params ? [params]: [])] as const;
    }

    
export const useGetTerminalOrganisationsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetTerminalOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTerminalOrganisationsQueryKey(params);

  const getTerminalOrganisations =  useGetTerminalOrganisationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>> = ({ signal }) => getTerminalOrganisations(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTerminalOrganisationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>>
export type GetTerminalOrganisationsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetTerminalOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetTerminalOrganisationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTerminalOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetTerminalOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTerminalOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetTerminalOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTerminalOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetTerminalOrganisationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalOrganisationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTerminalOrganisationsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useCreateTerminalOrganisationHook = () => {
        const createTerminalOrganisation = useMutator<OrganisationDto>();

        return useCallback((
    newOrganisationDto: NewOrganisationDto,
 signal?: AbortSignal
) => {
        return createTerminalOrganisation(
          {url: `/api/v2/terminal`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: newOrganisationDto, signal
    },
          );
        }, [createTerminalOrganisation])
      }
    


export const useCreateTerminalOrganisationMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateTerminalOrganisationHook>>>, TError,{data: NewOrganisationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateTerminalOrganisationHook>>>, TError,{data: NewOrganisationDto}, TContext> => {

const mutationKey = ['createTerminalOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createTerminalOrganisation =  useCreateTerminalOrganisationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateTerminalOrganisationHook>>>, {data: NewOrganisationDto}> = (props) => {
          const {data} = props ?? {};

          return  createTerminalOrganisation(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTerminalOrganisationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateTerminalOrganisationHook>>>>
    export type CreateTerminalOrganisationMutationBody = NewOrganisationDto
    export type CreateTerminalOrganisationMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreateTerminalOrganisation = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateTerminalOrganisationHook>>>, TError,{data: NewOrganisationDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateTerminalOrganisationHook>>>,
        TError,
        {data: NewOrganisationDto},
        TContext
      > => {

      const mutationOptions = useCreateTerminalOrganisationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetTerminalHook = () => {
        const getTerminal = useMutator<OrganisationDto>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {
        return getTerminal(
          {url: `/api/v2/terminal/${id}`, method: 'GET', signal
    },
          );
        }, [getTerminal])
      }
    

export const getGetTerminalQueryKey = (id?: string,) => {
    return [`/api/v2/terminal/${id}`] as const;
    }

    
export const useGetTerminalQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTerminalQueryKey(id);

  const getTerminal =  useGetTerminalHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>> = ({ signal }) => getTerminal(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetTerminalQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>>
export type GetTerminalQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetTerminal<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTerminal<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetTerminal<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetTerminal<TData = Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetTerminalHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetTerminalQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateTerminalOrganisationHook = () => {
        const updateTerminalOrganisation = useMutator<OrganisationDto>();

        return useCallback((
    id: string,
    organisationDto: OrganisationDto,
 ) => {
        return updateTerminalOrganisation(
          {url: `/api/v2/terminal/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: organisationDto
    },
          );
        }, [updateTerminalOrganisation])
      }
    


export const useUpdateTerminalOrganisationMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationHook>>>, TError,{id: string;data: OrganisationDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationHook>>>, TError,{id: string;data: OrganisationDto}, TContext> => {

const mutationKey = ['updateTerminalOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateTerminalOrganisation =  useUpdateTerminalOrganisationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationHook>>>, {id: string;data: OrganisationDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateTerminalOrganisation(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTerminalOrganisationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationHook>>>>
    export type UpdateTerminalOrganisationMutationBody = OrganisationDto
    export type UpdateTerminalOrganisationMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdateTerminalOrganisation = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationHook>>>, TError,{id: string;data: OrganisationDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationHook>>>,
        TError,
        {id: string;data: OrganisationDto},
        TContext
      > => {

      const mutationOptions = useUpdateTerminalOrganisationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteUserFromTerminalOrganisationHook = () => {
        const deleteUserFromTerminalOrganisation = useMutator<null>();

        return useCallback((
    emailOrId: string,
 ) => {
        return deleteUserFromTerminalOrganisation(
          {url: `/api/v2/terminal/user/${emailOrId}`, method: 'DELETE'
    },
          );
        }, [deleteUserFromTerminalOrganisation])
      }
    


export const useDeleteUserFromTerminalOrganisationMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserFromTerminalOrganisationHook>>>, TError,{emailOrId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserFromTerminalOrganisationHook>>>, TError,{emailOrId: string}, TContext> => {

const mutationKey = ['deleteUserFromTerminalOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteUserFromTerminalOrganisation =  useDeleteUserFromTerminalOrganisationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteUserFromTerminalOrganisationHook>>>, {emailOrId: string}> = (props) => {
          const {emailOrId} = props ?? {};

          return  deleteUserFromTerminalOrganisation(emailOrId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserFromTerminalOrganisationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteUserFromTerminalOrganisationHook>>>>
    
    export type DeleteUserFromTerminalOrganisationMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteUserFromTerminalOrganisation = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserFromTerminalOrganisationHook>>>, TError,{emailOrId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteUserFromTerminalOrganisationHook>>>,
        TError,
        {emailOrId: string},
        TContext
      > => {

      const mutationOptions = useDeleteUserFromTerminalOrganisationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteAccountNumberForTerminalOrganisationHook = () => {
        const deleteAccountNumberForTerminalOrganisation = useMutator<null>();

        return useCallback((
    id: string,
    accountNumber: string,
 ) => {
        return deleteAccountNumberForTerminalOrganisation(
          {url: `/api/v2/terminal/${id}/account-numbers/${accountNumber}`, method: 'DELETE'
    },
          );
        }, [deleteAccountNumberForTerminalOrganisation])
      }
    


export const useDeleteAccountNumberForTerminalOrganisationMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForTerminalOrganisationHook>>>, TError,{id: string;accountNumber: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForTerminalOrganisationHook>>>, TError,{id: string;accountNumber: string}, TContext> => {

const mutationKey = ['deleteAccountNumberForTerminalOrganisation'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteAccountNumberForTerminalOrganisation =  useDeleteAccountNumberForTerminalOrganisationHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForTerminalOrganisationHook>>>, {id: string;accountNumber: string}> = (props) => {
          const {id,accountNumber} = props ?? {};

          return  deleteAccountNumberForTerminalOrganisation(id,accountNumber,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteAccountNumberForTerminalOrganisationMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForTerminalOrganisationHook>>>>
    
    export type DeleteAccountNumberForTerminalOrganisationMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteAccountNumberForTerminalOrganisation = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForTerminalOrganisationHook>>>, TError,{id: string;accountNumber: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteAccountNumberForTerminalOrganisationHook>>>,
        TError,
        {id: string;accountNumber: string},
        TContext
      > => {

      const mutationOptions = useDeleteAccountNumberForTerminalOrganisationMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useUpdateTerminalOrganisationForUserHook = () => {
        const updateTerminalOrganisationForUser = useMutator<null>();

        return useCallback((
    emailOrId: string,
    organisationId: string,
 ) => {
        return updateTerminalOrganisationForUser(
          {url: `/api/v2/users/${emailOrId}/terminal/${organisationId}`, method: 'PUT'
    },
          );
        }, [updateTerminalOrganisationForUser])
      }
    


export const useUpdateTerminalOrganisationForUserMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationForUserHook>>>, TError,{emailOrId: string;organisationId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationForUserHook>>>, TError,{emailOrId: string;organisationId: string}, TContext> => {

const mutationKey = ['updateTerminalOrganisationForUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateTerminalOrganisationForUser =  useUpdateTerminalOrganisationForUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationForUserHook>>>, {emailOrId: string;organisationId: string}> = (props) => {
          const {emailOrId,organisationId} = props ?? {};

          return  updateTerminalOrganisationForUser(emailOrId,organisationId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTerminalOrganisationForUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationForUserHook>>>>
    
    export type UpdateTerminalOrganisationForUserMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdateTerminalOrganisationForUser = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationForUserHook>>>, TError,{emailOrId: string;organisationId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateTerminalOrganisationForUserHook>>>,
        TError,
        {emailOrId: string;organisationId: string},
        TContext
      > => {

      const mutationOptions = useUpdateTerminalOrganisationForUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetBillingUnitsHook = () => {
        const getBillingUnits = useMutator<PageBillingUnitDto>();

        return useCallback((
    params?: GetBillingUnitsParams,
 signal?: AbortSignal
) => {
        return getBillingUnits(
          {url: `/api/v2/ccc/billing-unit`, method: 'GET',
        params, signal
    },
          );
        }, [getBillingUnits])
      }
    

export const getGetBillingUnitsQueryKey = (params?: GetBillingUnitsParams,) => {
    return [`/api/v2/ccc/billing-unit`, ...(params ? [params]: [])] as const;
    }

    
export const useGetBillingUnitsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetBillingUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingUnitsQueryKey(params);

  const getBillingUnits =  useGetBillingUnitsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>> = ({ signal }) => getBillingUnits(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingUnitsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>>
export type GetBillingUnitsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetBillingUnits<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetBillingUnitsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUnits<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetBillingUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUnits<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetBillingUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBillingUnits<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetBillingUnitsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBillingUnitsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useCreateBillingUnitHook = () => {
        const createBillingUnit = useMutator<null>();

        return useCallback((
    billingUnitDto: BillingUnitDto,
 signal?: AbortSignal
) => {
        return createBillingUnit(
          {url: `/api/v2/ccc/billing-unit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: billingUnitDto, signal
    },
          );
        }, [createBillingUnit])
      }
    


export const useCreateBillingUnitMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateBillingUnitHook>>>, TError,{data: BillingUnitDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateBillingUnitHook>>>, TError,{data: BillingUnitDto}, TContext> => {

const mutationKey = ['createBillingUnit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createBillingUnit =  useCreateBillingUnitHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateBillingUnitHook>>>, {data: BillingUnitDto}> = (props) => {
          const {data} = props ?? {};

          return  createBillingUnit(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateBillingUnitMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateBillingUnitHook>>>>
    export type CreateBillingUnitMutationBody = BillingUnitDto
    export type CreateBillingUnitMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreateBillingUnit = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateBillingUnitHook>>>, TError,{data: BillingUnitDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateBillingUnitHook>>>,
        TError,
        {data: BillingUnitDto},
        TContext
      > => {

      const mutationOptions = useCreateBillingUnitMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetBillingUnitByIdHook = () => {
        const getBillingUnitById = useMutator<BillingUnitDto>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {
        return getBillingUnitById(
          {url: `/api/v2/ccc/billing-unit/${id}`, method: 'GET', signal
    },
          );
        }, [getBillingUnitById])
      }
    

export const getGetBillingUnitByIdQueryKey = (id?: string,) => {
    return [`/api/v2/ccc/billing-unit/${id}`] as const;
    }

    
export const useGetBillingUnitByIdQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingUnitByIdQueryKey(id);

  const getBillingUnitById =  useGetBillingUnitByIdHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>> = ({ signal }) => getBillingUnitById(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingUnitByIdQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>>
export type GetBillingUnitByIdQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetBillingUnitById<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUnitById<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUnitById<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBillingUnitById<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitByIdHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBillingUnitByIdQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useUpdateBillingUnitHook = () => {
        const updateBillingUnit = useMutator<null>();

        return useCallback((
    id: string,
    billingUnitDto: BillingUnitDto,
 ) => {
        return updateBillingUnit(
          {url: `/api/v2/ccc/billing-unit/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: billingUnitDto
    },
          );
        }, [updateBillingUnit])
      }
    


export const useUpdateBillingUnitMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateBillingUnitHook>>>, TError,{id: string;data: BillingUnitDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateBillingUnitHook>>>, TError,{id: string;data: BillingUnitDto}, TContext> => {

const mutationKey = ['updateBillingUnit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateBillingUnit =  useUpdateBillingUnitHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateBillingUnitHook>>>, {id: string;data: BillingUnitDto}> = (props) => {
          const {id,data} = props ?? {};

          return  updateBillingUnit(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateBillingUnitMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateBillingUnitHook>>>>
    export type UpdateBillingUnitMutationBody = BillingUnitDto
    export type UpdateBillingUnitMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdateBillingUnit = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateBillingUnitHook>>>, TError,{id: string;data: BillingUnitDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateBillingUnitHook>>>,
        TError,
        {id: string;data: BillingUnitDto},
        TContext
      > => {

      const mutationOptions = useUpdateBillingUnitMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useDeleteBillingUnitHook = () => {
        const deleteBillingUnit = useMutator<null>();

        return useCallback((
    id: string,
 ) => {
        return deleteBillingUnit(
          {url: `/api/v2/ccc/billing-unit/${id}`, method: 'DELETE'
    },
          );
        }, [deleteBillingUnit])
      }
    


export const useDeleteBillingUnitMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteBillingUnitHook>>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteBillingUnitHook>>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteBillingUnit'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteBillingUnit =  useDeleteBillingUnitHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteBillingUnitHook>>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteBillingUnit(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteBillingUnitMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteBillingUnitHook>>>>
    
    export type DeleteBillingUnitMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useDeleteBillingUnit = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteBillingUnitHook>>>, TError,{id: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteBillingUnitHook>>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = useDeleteBillingUnitMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetBillingUnitOrganisationsHook = () => {
        const getBillingUnitOrganisations = useMutator<OrganisationDto[]>();

        return useCallback((
    id: string,
 signal?: AbortSignal
) => {
        return getBillingUnitOrganisations(
          {url: `/api/v2/ccc/billing-unit/${id}/organisations`, method: 'GET', signal
    },
          );
        }, [getBillingUnitOrganisations])
      }
    

export const getGetBillingUnitOrganisationsQueryKey = (id?: string,) => {
    return [`/api/v2/ccc/billing-unit/${id}/organisations`] as const;
    }

    
export const useGetBillingUnitOrganisationsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingUnitOrganisationsQueryKey(id);

  const getBillingUnitOrganisations =  useGetBillingUnitOrganisationsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>> = ({ signal }) => getBillingUnitOrganisations(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingUnitOrganisationsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>>
export type GetBillingUnitOrganisationsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetBillingUnitOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUnitOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUnitOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBillingUnitOrganisations<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitOrganisationsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBillingUnitOrganisationsQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetFlowTypesHook = () => {
        const getFlowTypes = useMutator<FlowTypesResultDto>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return getFlowTypes(
          {url: `/api/v2/ppp/flow-types`, method: 'GET', signal
    },
          );
        }, [getFlowTypes])
      }
    

export const getGetFlowTypesQueryKey = () => {
    return [`/api/v2/ppp/flow-types`] as const;
    }

    
export const useGetFlowTypesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFlowTypesQueryKey();

  const getFlowTypes =  useGetFlowTypesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>> = ({ signal }) => getFlowTypes(signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetFlowTypesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>>
export type GetFlowTypesQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetFlowTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFlowTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetFlowTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetFlowTypes<TData = Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetFlowTypesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetFlowTypesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const usePidSearchHook = () => {
        const pidSearch = useMutator<EasySearchResultDto>();

        return useCallback((
    params: PidSearchParams,
 signal?: AbortSignal
) => {
        return pidSearch(
          {url: `/api/v2/ppp/pid-search`, method: 'GET',
        params, signal
    },
          );
        }, [pidSearch])
      }
    

export const getPidSearchQueryKey = (params?: PidSearchParams,) => {
    return [`/api/v2/ppp/pid-search`, ...(params ? [params]: [])] as const;
    }

    
export const usePidSearchQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params: PidSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getPidSearchQueryKey(params);

  const pidSearch =  usePidSearchHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>> = ({ signal }) => pidSearch(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type PidSearchQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>>
export type PidSearchQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function usePidSearch<TData = Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: PidSearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePidSearch<TData = Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: PidSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function usePidSearch<TData = Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: PidSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function usePidSearch<TData = Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: PidSearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePidSearchHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = usePidSearchQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useGetBlobsHook = () => {
        const getBlobs = useMutator<Blob>();

        return useCallback((
    params: GetBlobsParams,
 signal?: AbortSignal
) => {
        return getBlobs(
          {url: `/api/v2/ppp/blobs`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
          );
        }, [getBlobs])
      }
    

export const getGetBlobsQueryKey = (params?: GetBlobsParams,) => {
    return [`/api/v2/ppp/blobs`, ...(params ? [params]: [])] as const;
    }

    
export const useGetBlobsQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params: GetBlobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBlobsQueryKey(params);

  const getBlobs =  useGetBlobsHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>> = ({ signal }) => getBlobs(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBlobsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>>
export type GetBlobsQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetBlobs<TData = Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: GetBlobsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBlobs<TData = Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: GetBlobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBlobs<TData = Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: GetBlobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBlobs<TData = Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: GetBlobsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBlobsHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBlobsQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useInterventionExportHook = () => {
        const interventionExport = useMutator<Blob>();

        return useCallback((
    params: InterventionExportParams,
 signal?: AbortSignal
) => {
        return interventionExport(
          {url: `/api/v2/intervention/export`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
          );
        }, [interventionExport])
      }
    

export const getInterventionExportQueryKey = (params?: InterventionExportParams,) => {
    return [`/api/v2/intervention/export`, ...(params ? [params]: [])] as const;
    }

    
export const useInterventionExportQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params: InterventionExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getInterventionExportQueryKey(params);

  const interventionExport =  useInterventionExportHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>> = ({ signal }) => interventionExport(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type InterventionExportQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>>
export type InterventionExportQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useInterventionExport<TData = Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: InterventionExportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInterventionExport<TData = Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: InterventionExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useInterventionExport<TData = Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: InterventionExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useInterventionExport<TData = Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: InterventionExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useInterventionExportHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useInterventionExportQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a promo code by its key
 */
export const useGetPromoCodeHook = () => {
        const getPromoCode = useMutator<PromoCodeDto>();

        return useCallback((
    key: string,
 signal?: AbortSignal
) => {
        return getPromoCode(
          {url: `/api/v2/promocode/${key}`, method: 'GET', signal
    },
          );
        }, [getPromoCode])
      }
    

export const getGetPromoCodeQueryKey = (key?: string,) => {
    return [`/api/v2/promocode/${key}`] as const;
    }

    
export const useGetPromoCodeQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromoCodeQueryKey(key);

  const getPromoCode =  useGetPromoCodeHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>> = ({ signal }) => getPromoCode(key, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(key),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromoCodeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>>
export type GetPromoCodeQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetPromoCode<TData = Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 key: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromoCode<TData = Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromoCode<TData = Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromoCode<TData = Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 key: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodeHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPromoCodeQueryOptions(key,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update an existing promo code
 */
export const useUpdatePromoCodeHook = () => {
        const updatePromoCode = useMutator<null>();

        return useCallback((
    key: string,
    promoCodeDto: PromoCodeDto,
 ) => {
        return updatePromoCode(
          {url: `/api/v2/promocode/${key}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: promoCodeDto
    },
          );
        }, [updatePromoCode])
      }
    


export const useUpdatePromoCodeMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdatePromoCodeHook>>>, TError,{key: string;data: PromoCodeDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdatePromoCodeHook>>>, TError,{key: string;data: PromoCodeDto}, TContext> => {

const mutationKey = ['updatePromoCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updatePromoCode =  useUpdatePromoCodeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdatePromoCodeHook>>>, {key: string;data: PromoCodeDto}> = (props) => {
          const {key,data} = props ?? {};

          return  updatePromoCode(key,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdatePromoCodeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdatePromoCodeHook>>>>
    export type UpdatePromoCodeMutationBody = PromoCodeDto
    export type UpdatePromoCodeMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useUpdatePromoCode = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdatePromoCodeHook>>>, TError,{key: string;data: PromoCodeDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdatePromoCodeHook>>>,
        TError,
        {key: string;data: PromoCodeDto},
        TContext
      > => {

      const mutationOptions = useUpdatePromoCodeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Get all promo codes with optional filtering by user-generated status
 */
export const useGetPromoCodesHook = () => {
        const getPromoCodes = useMutator<PromoCodeDto[]>();

        return useCallback((
    params?: GetPromoCodesParams,
 signal?: AbortSignal
) => {
        return getPromoCodes(
          {url: `/api/v2/promocode`, method: 'GET',
        params, signal
    },
          );
        }, [getPromoCodes])
      }
    

export const getGetPromoCodesQueryKey = (params?: GetPromoCodesParams,) => {
    return [`/api/v2/promocode`, ...(params ? [params]: [])] as const;
    }

    
export const useGetPromoCodesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(params?: GetPromoCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPromoCodesQueryKey(params);

  const getPromoCodes =  useGetPromoCodesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>> = ({ signal }) => getPromoCodes(params, signal);

      

      

   return  { queryKey, queryFn,   staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPromoCodesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>>
export type GetPromoCodesQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetPromoCodes<TData = Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params: undefined |  GetPromoCodesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromoCodes<TData = Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetPromoCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPromoCodes<TData = Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetPromoCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPromoCodes<TData = Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 params?: GetPromoCodesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetPromoCodesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetPromoCodesQueryOptions(params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Create a new promo code
 */
export const useCreatePromoCodeHook = () => {
        const createPromoCode = useMutator<null>();

        return useCallback((
    promoCodeDto: PromoCodeDto,
 signal?: AbortSignal
) => {
        return createPromoCode(
          {url: `/api/v2/promocode`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: promoCodeDto, signal
    },
          );
        }, [createPromoCode])
      }
    


export const useCreatePromoCodeMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreatePromoCodeHook>>>, TError,{data: PromoCodeDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreatePromoCodeHook>>>, TError,{data: PromoCodeDto}, TContext> => {

const mutationKey = ['createPromoCode'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createPromoCode =  useCreatePromoCodeHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreatePromoCodeHook>>>, {data: PromoCodeDto}> = (props) => {
          const {data} = props ?? {};

          return  createPromoCode(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreatePromoCodeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreatePromoCodeHook>>>>
    export type CreatePromoCodeMutationBody = PromoCodeDto
    export type CreatePromoCodeMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useCreatePromoCode = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreatePromoCodeHook>>>, TError,{data: PromoCodeDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreatePromoCodeHook>>>,
        TError,
        {data: PromoCodeDto},
        TContext
      > => {

      const mutationOptions = useCreatePromoCodeMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
/**
 * Generate multiple promo codes
 */
export const useGeneratePromoCodesHook = () => {
        const generatePromoCodes = useMutator<string>();

        return useCallback((
    generatePromoCodesCommand: GeneratePromoCodesCommand,
 signal?: AbortSignal
) => {
        return generatePromoCodes(
          {url: `/api/v2/promocodes`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: generatePromoCodesCommand, signal
    },
          );
        }, [generatePromoCodes])
      }
    


export const useGeneratePromoCodesMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useGeneratePromoCodesHook>>>, TError,{data: GeneratePromoCodesCommand}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useGeneratePromoCodesHook>>>, TError,{data: GeneratePromoCodesCommand}, TContext> => {

const mutationKey = ['generatePromoCodes'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const generatePromoCodes =  useGeneratePromoCodesHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useGeneratePromoCodesHook>>>, {data: GeneratePromoCodesCommand}> = (props) => {
          const {data} = props ?? {};

          return  generatePromoCodes(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GeneratePromoCodesMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGeneratePromoCodesHook>>>>
    export type GeneratePromoCodesMutationBody = GeneratePromoCodesCommand
    export type GeneratePromoCodesMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useGeneratePromoCodes = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useGeneratePromoCodesHook>>>, TError,{data: GeneratePromoCodesCommand}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useGeneratePromoCodesHook>>>,
        TError,
        {data: GeneratePromoCodesCommand},
        TContext
      > => {

      const mutationOptions = useGeneratePromoCodesMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const useGetBillingUnitsForAdminHook = () => {
        const getBillingUnitsForAdmin = useMutator<PageBillingUnitDto>();

        return useCallback((
    adminUserId: string,
    params?: GetBillingUnitsForAdminParams,
 signal?: AbortSignal
) => {
        return getBillingUnitsForAdmin(
          {url: `/api/v2/ccc/admin-users/${adminUserId}/billing-units`, method: 'GET',
        params, signal
    },
          );
        }, [getBillingUnitsForAdmin])
      }
    

export const getGetBillingUnitsForAdminQueryKey = (adminUserId?: string,
    params?: GetBillingUnitsForAdminParams,) => {
    return [`/api/v2/ccc/admin-users/${adminUserId}/billing-units`, ...(params ? [params]: [])] as const;
    }

    
export const useGetBillingUnitsForAdminQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(adminUserId: string,
    params?: GetBillingUnitsForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetBillingUnitsForAdminQueryKey(adminUserId,params);

  const getBillingUnitsForAdmin =  useGetBillingUnitsForAdminHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>> = ({ signal }) => getBillingUnitsForAdmin(adminUserId,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(adminUserId),  staleTime: 10000,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetBillingUnitsForAdminQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>>
export type GetBillingUnitsForAdminQueryError = ErrorType<ErrorResponse | ErrorResponse>


export function useGetBillingUnitsForAdmin<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 adminUserId: string,
    params: undefined |  GetBillingUnitsForAdminParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUnitsForAdmin<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 adminUserId: string,
    params?: GetBillingUnitsForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetBillingUnitsForAdmin<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 adminUserId: string,
    params?: GetBillingUnitsForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetBillingUnitsForAdmin<TData = Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>, TError = ErrorType<ErrorResponse | ErrorResponse>>(
 adminUserId: string,
    params?: GetBillingUnitsForAdminParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetBillingUnitsForAdminHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useGetBillingUnitsForAdminQueryOptions(adminUserId,params,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const useAssignBillingUnitsToUserHook = () => {
        const assignBillingUnitsToUser = useMutator<null>();

        return useCallback((
    adminUserId: string,
    assignBillingUnitsToUserBody?: string[],
 signal?: AbortSignal
) => {
        return assignBillingUnitsToUser(
          {url: `/api/v2/ccc/admin-users/${adminUserId}/billing-units`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: assignBillingUnitsToUserBody, signal
    },
          );
        }, [assignBillingUnitsToUser])
      }
    


export const useAssignBillingUnitsToUserMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAssignBillingUnitsToUserHook>>>, TError,{adminUserId: string;data: string[]}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAssignBillingUnitsToUserHook>>>, TError,{adminUserId: string;data: string[]}, TContext> => {

const mutationKey = ['assignBillingUnitsToUser'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const assignBillingUnitsToUser =  useAssignBillingUnitsToUserHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAssignBillingUnitsToUserHook>>>, {adminUserId: string;data: string[]}> = (props) => {
          const {adminUserId,data} = props ?? {};

          return  assignBillingUnitsToUser(adminUserId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AssignBillingUnitsToUserMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAssignBillingUnitsToUserHook>>>>
    export type AssignBillingUnitsToUserMutationBody = string[]
    export type AssignBillingUnitsToUserMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const useAssignBillingUnitsToUser = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAssignBillingUnitsToUserHook>>>, TError,{adminUserId: string;data: string[]}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useAssignBillingUnitsToUserHook>>>,
        TError,
        {adminUserId: string;data: string[]},
        TContext
      > => {

      const mutationOptions = useAssignBillingUnitsToUserMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePostSelfOnboardingResetLimitsHook = () => {
        const postSelfOnboardingResetLimits = useMutator<null>();

        return useCallback((
    selfOnboardingCustomerAdminRequest: SelfOnboardingCustomerAdminRequest,
 signal?: AbortSignal
) => {
        return postSelfOnboardingResetLimits(
          {url: `/api/v2/self-onboarding/reset-limits`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selfOnboardingCustomerAdminRequest, signal
    },
          );
        }, [postSelfOnboardingResetLimits])
      }
    


export const usePostSelfOnboardingResetLimitsMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingResetLimitsHook>>>, TError,{data: SelfOnboardingCustomerAdminRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingResetLimitsHook>>>, TError,{data: SelfOnboardingCustomerAdminRequest}, TContext> => {

const mutationKey = ['postSelfOnboardingResetLimits'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postSelfOnboardingResetLimits =  usePostSelfOnboardingResetLimitsHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingResetLimitsHook>>>, {data: SelfOnboardingCustomerAdminRequest}> = (props) => {
          const {data} = props ?? {};

          return  postSelfOnboardingResetLimits(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSelfOnboardingResetLimitsMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingResetLimitsHook>>>>
    export type PostSelfOnboardingResetLimitsMutationBody = SelfOnboardingCustomerAdminRequest
    export type PostSelfOnboardingResetLimitsMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const usePostSelfOnboardingResetLimits = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingResetLimitsHook>>>, TError,{data: SelfOnboardingCustomerAdminRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingResetLimitsHook>>>,
        TError,
        {data: SelfOnboardingCustomerAdminRequest},
        TContext
      > => {

      const mutationOptions = usePostSelfOnboardingResetLimitsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    
export const usePostSelfOnboardingRemoveStatusHook = () => {
        const postSelfOnboardingRemoveStatus = useMutator<null>();

        return useCallback((
    selfOnboardingCustomerAdminRequest: SelfOnboardingCustomerAdminRequest,
 signal?: AbortSignal
) => {
        return postSelfOnboardingRemoveStatus(
          {url: `/api/v2/self-onboarding/remove-status`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selfOnboardingCustomerAdminRequest, signal
    },
          );
        }, [postSelfOnboardingRemoveStatus])
      }
    


export const usePostSelfOnboardingRemoveStatusMutationOptions = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingRemoveStatusHook>>>, TError,{data: SelfOnboardingCustomerAdminRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingRemoveStatusHook>>>, TError,{data: SelfOnboardingCustomerAdminRequest}, TContext> => {

const mutationKey = ['postSelfOnboardingRemoveStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const postSelfOnboardingRemoveStatus =  usePostSelfOnboardingRemoveStatusHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingRemoveStatusHook>>>, {data: SelfOnboardingCustomerAdminRequest}> = (props) => {
          const {data} = props ?? {};

          return  postSelfOnboardingRemoveStatus(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostSelfOnboardingRemoveStatusMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingRemoveStatusHook>>>>
    export type PostSelfOnboardingRemoveStatusMutationBody = SelfOnboardingCustomerAdminRequest
    export type PostSelfOnboardingRemoveStatusMutationError = ErrorType<ErrorResponse | ErrorResponse>

    export const usePostSelfOnboardingRemoveStatus = <TError = ErrorType<ErrorResponse | ErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingRemoveStatusHook>>>, TError,{data: SelfOnboardingCustomerAdminRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof usePostSelfOnboardingRemoveStatusHook>>>,
        TError,
        {data: SelfOnboardingCustomerAdminRequest},
        TContext
      > => {

      const mutationOptions = usePostSelfOnboardingRemoveStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
export * from './index';
